/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-use-before-define */
import type {ChangeEvent, MouseEvent} from 'react';
import {Button, Form, InputGroup} from 'react-bootstrap';
import {useNavigate, useLocation} from 'react-router-dom';
import {useEffect, useRef, useState, useCallback} from 'react';
import {useForm, useFieldArray, useWatch} from 'react-hook-form';
import {format, parseISO} from 'date-fns';
import {toast} from 'react-toastify';
import type {SubmitHandler} from 'react-hook-form';
import AsyncSelect from 'react-select/async';
// eslint-disable-next-line import/named
import {confirmAlert} from 'react-confirm-alert';
// eslint-disable-next-line import/no-extraneous-dependencies
import {Tooltip as ReactTooltip} from 'react-tooltip';
import moment from 'moment-timezone';
import {
	useGetSystemConfigQuery,
	useUpdateSystemConfigMutation,
	useLazyGetSubscriptionDataPlanTemplateQuery,
	useSubscriptionDataMutation,
	useDeleteDataPlanInstanceMutation,
	useUpdateSubscriptionDataMutation,
	useUpdateSubscriptionSupiDataMutation,
	useUpdateSubscriptionGpsiDataMutation,
	useLazyGetPlanDataQuery,
	useResetUsageDataPlanInstanceMutation,
	useUpdateConsumedQuotaMutation,
} from 'services';

import LayoutMain from 'components/Layouts/LayoutMain';
import ModalPlanAssignation from './ModalPlanAssignation';

import type {
	DataPlanTemplate,
	HomeZone,
	Option,
	PlanData,
	CurrentDataPlan,
	SubscriptionData,
	SmPolicySnssaiData,
	PersonalPCCS,
} from 'interfaces';

import type {GetOptionLabel} from 'react-select';
import {REGEX} from 'constants/regex';
import {QuotaManager} from 'constants/QuotaManagerType';

type GenericObject<T> = {
	parameter: T;
	type: string;
};

const stylePadding = {paddingLeft: '0.5rem'};

const HOMEZONE_TOOLTIPS = [
	{
		id: 'mcc',
		place: 'top',
		content: 'Example: 000',
	},
	{
		id: 'mnc',
		place: 'top',
		content: 'Example: 000',
	},
	{
		id: 'tac',
		place: 'top',
		content: 'Example: 0000',
	},
	{
		id: 'eci',
		place: 'top',
		content: 'Example: 0000000',
	},
	{
		id: 'sac',
		place: 'top',
		content: 'Example: 0000',
	},
	{
		id: 'lac',
		place: 'top',
		content: 'Example: 0000',
	},
];

const QOS_TOOLTIPS = [
	{
		id: '_5qi',
		place: 'top',
		content: 'Only positive numbers',
	},
	{
		id: 'maxUlValue',
		place: 'top',
		content: 'Only positive numbers',
	},
	{
		id: 'maxDlValue',
		place: 'top',
		content: 'Only positive numbers',
	},
	{
		id: 'prio',
		place: 'top',
		content: 'Select value',
	},
];

const PCC_TOOLTIPS = [
	{
		id: 'dnn',
		place: 'top',
		content: 'Insert value',
	},
	{
		id: 'parentalControls',
		place: 'top',
		content: 'Insert value',
	},
];

const PLAN_TOOLTIPS = [
	{
		id: 'duration',
		place: 'top',
		content: 'Duration',
	},
	{
		id: 'totalVolume',
		place: 'top',
		content: 'Total Volume',
	},
	{
		id: 'downlinkVolume',
		place: 'top',
		content: 'Downlink Volume',
	},
	{
		id: 'uplinkVolume',
		place: 'top',
		content: 'Uplink Volume',
	},
];

type FormData = {
	subscriberId: string;
	supi: string;
	gpsi: string;
	operator: string;
	category: string;
};

const SubscriberProfileDetail = () => {
	const navigate = useNavigate();
	const location = useLocation();

	// api
	const [getDataPlanTemplate, {isLoading: isLoadingDataPlanTemplate}] =
		useLazyGetSubscriptionDataPlanTemplateQuery();
	const [getPlanData, {isLoading: isLoadingPlanData}] =
		useLazyGetPlanDataQuery();

	const [deleteRow, {isLoading: isLoadingRemovePlan}] =
		useDeleteDataPlanInstanceMutation();
	const [saveData, {isLoading}] = useSubscriptionDataMutation();
	const [resetUsageRow, {isLoading: isLoadingResetUsagePlan}] =
		useResetUsageDataPlanInstanceMutation();

	const [requestUsageReportUeId, {isLoading: isLoadingPlanes}] =
		useUpdateConsumedQuotaMutation();

	const [updateData, {isLoading: isLoadingSubscription}] =
		useUpdateSubscriptionDataMutation();

	const [updateSupiData, {isLoading: isLoadingUpdateSubscriptionSupi}] =
		useUpdateSubscriptionSupiDataMutation();

	const [updateGpsiData, {isLoading: isLoadingUpdateSubscriptionGpsi}] =
		useUpdateSubscriptionGpsiDataMutation();
	const timer = useRef<unknown>();

	const {state} = location;

	const [isEdit, setIsEdit] = useState(false);
	const [dataResult, setDataResult] = useState<SubscriptionData | null>(null);

	useEffect(() => {
		if (state?.subscriberId) {
			setIsEdit(state?.subscriberId?.length > 0);
			setSubscriberIdState(state?.subscriberId);
		}
	}, [state?.subscriberId]);

	const [formData, setFormData] = useState<IForm | null | any>({
		contactInfo: undefined,
		formDnn: [],
		homeZones: [],
		personalPCCs: undefined,
		personalQoS: undefined,
	});

	const [activeForm, setActiveForm] = useState(false);
	const [planSelected, setPlanSelected] = useState<DataPlanTemplate>();
	const [activePlan, setActivePlan] = useState(false);
	const [subscriberIdState, setSubscriberIdState] = useState('');
	const [planData, setPlanData] = useState<CurrentDataPlan[]>([]);
	const [isValidForm, setIsValidForm] = useState(false);

	// validation form
	const {
		register,
		handleSubmit,
		formState: {errors, isValid},
	} = useForm<FormData>({
		mode: 'all',
		defaultValues: defaultData(state),
	});

	const handleIsValid = (valid: boolean) => setIsValidForm(valid);

	useEffect(() => setIsValidForm(isValid), [isValid]);

	const handleGetPlanData = useCallback(async () => {
		try {
			const result = await getPlanData(
				state?.subscriberId || dataResult?.supi || dataResult?.gpsi,
			).unwrap();
			if (result) {
				setPlanData(result as never);
				setActivePlan(true);
			}
		} catch (error) {
			console.error('Error:', error);
			if (error instanceof SyntaxError) {
				toast.error('Invalid JSON response from server.');
			} else {
				toast.error('An error occurred.');
			}
		}
	}, [getPlanData, state?.subscriberId, dataResult]);

	useEffect(() => {
		if (isEdit) {
			void handleGetPlanData();
		}
	}, [handleGetPlanData, isEdit]);

	const [openModalPlanAssignation, setOpenModalPlanAssignation] =
		useState(false);

	/**
	 * This function toggles the state of a modal window.
	 */
	const handleModalPlanAssignation = () =>
		setOpenModalPlanAssignation(prev => !prev);

	/**
	 * The handleChangeForms function updates the form data by merging the previous state with the new
	 * data.
	 * @param {IForm} data - The `data` parameter is an object of type `IForm`.
	 */
	const handleChangeForms = (data: IForm) => {
		// eslint-disable-next-line @typescript-eslint/no-unsafe-return
		setFormData((prevState: IForm | null | undefined) => ({
			...prevState,
			...data,
		}));
	};

	const {data = {}} = useGetSystemConfigQuery(undefined);
	const sortedData = Object.entries(data).sort((a, b) =>
		a[0].localeCompare(b[0]),
	);
	const isSystemSupi = sortedData.some(el => {
		if (el[1] === 'SUPI') {
			return true;
		}
	});

	/**
	 * The `onSubmit` function is an asynchronous function that handles form submission in a TypeScript
	 * React application.
	 */
	const onSubmit: SubmitHandler<FormData> = async dataum => {
		try {
			let subscriberId, supi, gpsi, operator;

			if (dataResult?.subscriberId) {
				({subscriberId, supi, gpsi, operator} = defaultData({
					...dataum,
					subscriberId: dataResult?.subscriberId,
				}));
			} else {
				({subscriberId, supi, gpsi, operator} = defaultData(dataum));
			}

			setSubscriberIdState(subscriberId);

			if (formData) {
				/**
				 * Processes the personalPCCs from formData and builds a new object structure.
				 *
				 * This method takes personalPCCs from formData, iterates over the entries,
				 * and constructs a new object where each unique `dnn` is a key, and its value
				 * is an object containing `pccRuleId` and `crbn`. If a `dnn` already exists in
				 * the accumulator, it checks if the `pccRuleId` is not already present before
				 * adding it to the list of `pccRuleId` and `crbn`.
				 *
				 * @param {Object} formData - The form data containing personalPCCs.
				 * @return {Object|null} An object with the new structure or null if personalPCCs is not present.
				 */
				const personalPCCs = formData.personalPCCs?.length
					? formData.personalPCCs.reduce(
							(acc: PersonalPCCS, value: FormPersonalPCCForm) => {
								const dnn = value.dnn?.trim();

								if (!dnn) {
									return acc;
								}

								acc[dnn] = {
									dnn,
									pccRuleId: value.parentalControls?.trim() || '',
									crbn: !!value.crbn,
								};

								return acc;
							},
							{} as PersonalPCCS,
					  )
					: null;

				const personalQos = formData.personalQos
					? Object.entries(formData.personalQos as never).reduce(
							(acc, [, value]) => ({
								...acc,
								[(value as any).dnn]: {
									'5qi': (value as any)._5qi,
									/* eslint-disable */
									maxbrUl: !(value as any).maxUlValue
										? null
										: (value as any).maxUlValue +
										  ' ' +
										  (value as any).maxUlUnit,
									maxbrDl: !(value as any).maxDlValue
										? null
										: (value as any).maxDlValue +
										  ' ' +
										  (value as any).maxDlUnit,
									gbrUl: !(value as any).gbrUlValue
										? null
										: (value as any).gbrUlValue +
										  ' ' +
										  (value as any).gbrUlUnit,
									gbrDl: !(value as any).gbrDlValue
										? null
										: (value as any).gbrDlValue +
										  ' ' +
										  (value as any).gbrDlUnit,
									/* eslint-disable */
									arp: {
										priorityLevel: (value as any).prio,
										preemptCap:
											(value as any).cap === '' || !(value as any).cap
												? 'NOT_PREEMPT'
												: 'MAY_PREEMPT',
										preemptVuln:
											(value as any).vuln === '' || !(value as any).vuln
												? 'NOT_PREEMPTABLE'
												: 'PREEMPTABLE',
									},
								},
							}),
							{},
					  )
					: null;

				const homeZones = formData?.homeZones?.length
					? formData?.homeZones.map((el: any) => {
							// Validation fields homezones
							if (!emptyULI(el)) {
								if (el.typeULI) {
									if (el.typeULI === '1') {
										return {
											utraLocation: {
												sai: {
													plmnId: {
														mcc: el.mcc || null,
														mnc: el.mnc || null,
													},
													lac: el.lac || null,
													sac: el.sac || null,
												},
											},
										};
									} else if (el.typeULI === '128') {
										return {
											eutraLocation: {
												tai: {
													plmnId: {
														mcc: el.mcc || null,
														mnc: el.mnc || null,
													},
													tac: el.tac || null,
												},
												ignoreEcgi: true,
												ignoreTai: false,
											},
										};
									} else if (el.typeULI === '129') {
										return {
											eutraLocation: {
												ecgi: {
													plmnId: {
														mcc: el.mcc || null,
														mnc: el.mnc || null,
													},
													eutraCellId: el.eci || null,
												},
												ignoreTai: true,
												ignoreEcgi: false,
											},
										};
									} else {
										return {
											eutraLocation: {
												tai: {
													plmnId: {
														mcc: el.mcc || null,
														mnc: el.mnc || null,
													},
													tac: el.tac || null,
												},
												ecgi: {
													plmnId: {
														mcc: el.mcc || null,
														mnc: el.mnc || null,
													},
													eutraCellId: el.eci || null,
												},
												ignoreEcgi: false,
												ignoreTai: false,
											},
										};
									}
								} else {
									toast.error(
										`${
											isEdit ? 'Update' : 'Create'
										}, there is a problem when trying to save the type of ULI!`,
									);
									throw new Error('Empty type ULI');
								}
							} else {
								toast.warning(
									`${
										isEdit ? 'Update' : 'Create'
									}, The ULI fields for the selected type are empty !`,
								);
								throw new Error('Empty ULI fields');
							}
					  })
					: null;

				// FIXME: data nuevo form smPolicySnssaiData, aqui llegan los datos del form.
				const formDnn = formData?.formDnn?.length
					? formData?.formDnn.map((el: any) => ({
							...el,
							online: el.online || 'blank',
							offline: el.offline || 'blank',
					  }))
					: null;

				const smPolicyDnnData = formData?.formDnn?.length
					? formData?.formDnn.map((el: any) => ({
							...el,
							online:
								el.online === null || el.online === 'blank' ? null : el.online,
							offline:
								el.offline === null || el.offline === 'blank'
									? null
									: el.offline,
							gbrUl:
								el.gbrUl === null || el.gbrUl.trim() === ''
									? null
									: el.gbrUl.trim() + ' ' + el.gbps,
							gbrDl:
								el.gbrDl === null || el.gbrDl.trim() === ''
									? null
									: el.gbrDl.trim() + ' ' + el._gbps,
							chInfo: {
								primaryChfAddress: el.primaryAddress,
								secondaryChfAddress: el.secondaryAddress,
							},
							refUmdLimitIds: el.refUmdLimitIds?.length
								? el.refUmdLimitIds?.map((el2: any) => ({
										limitId: el2.limitId,
										monitoringKey: el2.monitoringKey,
								  }))
								: null,
					  }))
					: null;

				const smPolicySnssaiData = formDnn
					? {
							additionalProp1: {
								snssai: {
									sst: '0',
									sd: 'FFFFFF',
								},
								smPolicyDnnData,
							},
					  }
					: null;

				const contactInfo = formData.contactInfo
					? Object.entries(formData.contactInfo as never).reduce(
							(acc, [key, value]) => ({
								...acc,
								email: (value as any).email,
								msisdn: (value as any).msisdn,
								contactInfo: (value as any).contactInfo,
							}),
							{},
					  )
					: null;

				const customFields = transformFormData(formData);

				const tmp = {
					subscriberId,
					supi,
					gpsi,
					operator,
					homeZones,
					personalQos,
					personalPCCs,
					smPolicySnssaiData,
					contactInfo,
					customFields,
				};

				// submit data
				if (isEdit) {
					updateSubscription(tmp)
						.then(updateResult => {
							toast.success('Update Successfully!');
						})
						.catch(error => {
							const errorType = isSupi ? 'GPSI' : 'SUPI';
							const errorMessage =
								error?.data?.message || 'An unexpected error occurred';
							toast.error(`Failed to update ${errorType}: ${errorMessage}`);
						});
				} else {
					const result = await saveData(tmp).unwrap();
					setDataResult(result);
					setSubscriberIdState(result?.subscriberId);
					setIsEdit(true);
				}

				setActivePlan(true);

				if (!isEdit) {
					toast.success('Create Successfully!');
				}
			}
		} catch (error) {
			console.error(error);
			return;
		}
	};

	const updateSubscription = async (tmp: any) => {
		try {
			if (isSupi) {
				const gpsi = state?.gpsi;
				const onlyUpdateGpsi = tmp.gpsi && gpsi && tmp.gpsi != gpsi;
				if (onlyUpdateGpsi) await updateGpsiData(tmp as any).unwrap();
			} else {
				const supi = state?.supi;
				const onlyUpdateSupi = tmp.gpsi && supi && tmp.supi != supi;
				if (onlyUpdateSupi) await updateSupiData(tmp as any).unwrap();
			}

			await updateData(tmp as any).unwrap();
		} catch (error: any) {
			console.error(`Error updating subscriber`, error);
		}
	};

	const emptyULI = (el: any): boolean => {
		return !el.mcc && !el.mnc && !el.tac && !el.eci && !el.lac && !el.sac;
	};

	/**
	 * The loadOptions function takes a keyword and a callback function as parameters, and after a 400ms
	 * delay, it calls the callback function with the result of the `getDataPlanTemplate` function.
	 * @param {string} keyword - The `keyword` parameter is a string that represents the search keyword or
	 * query that will be used to fetch data plan templates.
	 * @param callback - The `callback` parameter is a function that takes an argument `options` of type
	 * `Option` and does not return anything. It is used to handle the data returned from the
	 * `getDataPlanTemplate` function.
	 */
	const loadOptions = (
		keyword: string,
		callback: (options: Option[]) => void,
	) => {
		clearTimeout(timer.current as number);
		timer.current = setTimeout(async () => {
			const result = await getDataPlanTemplate(keyword || 'keyword').unwrap();
			callback(result as never);
		}, 500);
	};

	/* The above code is defining a functional component called `DropdownIndicator`. This component
	returns an `img` element with a source attribute pointing to a search.png image file. The image has
	a width and height of 16 pixels and a class name of "m-2". */
	const DropdownIndicator = () => (
		<img
			src="../../assets/img/search.png"
			alt="Search icon"
			width={16}
			height={16}
			className="m-2"
		/>
	);

	/**
	 * The handleChangeSelectPlan function updates the selected value in the state.
	 * @param {any} selected - The `selected` parameter is the value that is selected in a dropdown or
	 * select input.
	 */
	const handleChangeSelectPlan = (selected: DataPlanTemplate) =>
		setPlanSelected(selected);

	/**
	 * It returns an object with the properties that the modal component needs to render
	 * @param {DataPlanTemplate} item - DataPlanTemplate - The item that is being passed to the modal.
	 */
	const optionsRemoveModal = (item: CurrentDataPlan) => ({
		title: 'Do you really want to remove this plan instance?',
		message: 'This action can not be undone.',
		buttons: [
			{
				label: 'Yes',
				// eslint-disable-next-line @typescript-eslint/require-await
				onClick: async () => {
					try {
						await deleteRow({
							supi: subscriberIdState,
							planInstanceId: item.uid,
						});
						setPlanSelected(undefined);
						setPlanData(prevState =>
							prevState.filter(res => res.uid !== item.uid),
						);
						handleGetPlanData();
						toast.success('Deleted Plan Instance Successfully!');
					} catch (error) {
						console.error(error);
					}
				},
			},
			{
				label: 'No',
			},
		],
		closeOnEscape: true,
		closeOnClickOutside: true,
		keyCodeForClose: [8, 32],
		overlayClassName: 'overlay-custom-class-name',
	});

	/**
	 * It returns an object with the properties that the modal component needs to render
	 * @param {DataPlanTemplate} item - DataPlanTemplate - The item that is being passed to the modal.
	 */
	const optionsResetUsageModal = (item: CurrentDataPlan) => ({
		title:
			'Do you really want to reset allowed usage this ' +
			item.template +
			'  instance?',
		message: 'This action can not be undone.',
		buttons: [
			{
				label: 'Yes',
				// eslint-disable-next-line @typescript-eslint/require-await
				onClick: async () => {
					try {
						void resetUsageRow({supi: subscriberIdState, limitId: item.uid});
						setPlanSelected(undefined);
						await handleGetPlanData();
						toast.success(
							'Reset allowed usage for plan ' +
								item.template +
								' Successfully!',
						);
					} catch (error) {
						console.error(error);
					}
				},
			},
			{
				label: 'No',
			},
		],
		closeOnEscape: true,
		closeOnClickOutside: true,
		keyCodeForClose: [8, 32],
		overlayClassName: 'overlay-custom-class-name',
	});

	let isSupi = isEdit && state?.subscriberId == state?.supi;
	if (isEdit && !state?.subscriberId) isSupi = isSystemSupi;
	const isSupiIdentifier = isEdit
		? state?.subscriberId == state?.supi
		: isSystemSupi;

	/**
	 * The handleRemove function is used to display a confirmation modal before removing an item.
	 * @param {DataPlanTemplate} item - The `item` parameter is of type `DataPlanTemplate`. It represents
	 * the data plan template that needs to be removed.
	 */
	const handleRemove = (item: CurrentDataPlan) =>
		confirmAlert(optionsRemoveModal(item));

	/**
	 * The handleResetUsagePlan function is used to display a confirmation modal before removing an item.
	 * @param {DataPlanTemplate} item - The `item` parameter is of type `DataPlanTemplate`. It represents
	 * the data plan template that needs to be removed.
	 */
	const handleResetUsagePlan = (item: CurrentDataPlan) =>
		confirmAlert(optionsResetUsageModal(item));

	const handleRequestUsageReport = () =>
		confirmAlert(requestReportUsageModal());

	/**
	 * The function `handleUpdatePlanData` updates the `planData` state by adding a new `plan` object to
	 * the existing array.
	 * @param {PlanData} plan - The parameter `plan` is of type `PlanData`.
	 */
	const handleUpdatePlanData = () => {
		setPlanSelected(undefined);
		handleGetPlanData();
	};

	const formatNumber = (value: number) => {
		let stringValue = value.toString();
		let segments = [];
		while (stringValue.length > 3) {
			segments.unshift(stringValue.slice(-3));
			stringValue = stringValue.slice(0, -3);
		}
		if (stringValue.length > 0) {
			segments.unshift(stringValue);
		}
		return segments.join('.');
	};

	const [quotaManagerValue, setQuotaManagerValue] = useState<string>(
		QuotaManager.PCRF_MS,
	);

	const requestReportUsageModal = () => ({
		title: 'Do you want to request an updated usage report?',
		message:
			'The PGW will be asked to update the plan information associated with the Subscriber..',
		buttons: [
			{
				label: 'Yes',
				// eslint-disable-next-line @typescript-eslint/require-await
				onClick: async () => {
					try {
						const response = await requestUsageReportUeId({
							supi: subscriberIdState,
						});
						if ('data' in response) {
							setPlanSelected(undefined);
							await handleGetPlanData();
							toast.success('Update Quota(s) Consumed Successfully!');
						}
					} catch (error) {
						console.error(error);
					}
				},
			},
			{
				label: 'No',
			},
		],
		closeOnEscape: true,
		closeOnClickOutside: true,
		keyCodeForClose: [8, 32],
		overlayClassName: 'overlay-custom-class-name',
	});

	/* The above code is declaring a constant variable named "periodicity" and assigning it the value of
	the "period" property of the "resetPeriod" property of the "planSelected" object. The "?." operator
	is used to safely access nested properties, meaning if any of the properties in the chain are null
	or undefined, the expression will short-circuit and return undefined. */

	return (
		<LayoutMain
			isLoading={
				isLoadingDataPlanTemplate || isLoadingPlanData || isLoadingPlanes
			}>
			<div className="container-fluid">
				{/* Intro */}
				<div className="row">
					<div className="col-md-12">
						<h1 className="mt-2">Subscriber Profile Management</h1>
					</div>
				</div>

				<nav aria-label="breadcrumb">
					<ol className="breadcrumb">
						<li className="breadcrumb-item">
							<button
								className="text-primary border-0 p-0"
								onClick={() => navigate(-1)}>
								Subscriber Profile Management
							</button>
						</li>
						<li className="breadcrumb-item active" aria-current="page">
							{isEdit ? 'Edit' : 'Create'}
						</li>
					</ol>
				</nav>

				{/* Subscriber Profile Management*/}
				<Form className="row mt-4" onSubmit={handleSubmit(onSubmit)}>
					<div className="col-md-12">
						<div className="card-tasks card">
							<div className="card-header">
								<i className="bi bi-person-lines-fill mr-3 float-left text-primary bi-2-5" />
								<h2 className="card-title">{`Subscriber ID${
									// eslint-disable-next-line @typescript-eslint/restrict-plus-operands
									isEdit
										? `: ${
												state?.subscriberId
													? state.subscriberId
													: dataResult?.subscriberId
													? dataResult.subscriberId
													: dataResult?.supi
										  }`
										: ''
								}`}</h2>
								<p className="card-category">{isEdit ? 'Edit' : 'Create'}</p>
							</div>
							<div className="card-body">
								<div className="mt-4">
									<div className="row mb-5">
										{/* Profile detail */}
										<div className="col-xs-12 col-xl-7">
											<h2>Profile detail</h2>

											<InputGroup className="mb-3">
												<InputGroup.Text style={stylePadding}>
													SUPI
												</InputGroup.Text>
												<Form.Control
													id="supi"
													disabled={
														isEdit && state?.subscriberId == state?.supi
													}
													aria-label="supi"
													{...register('supi', {
														pattern: {
															value: new RegExp(REGEX.IMSI),
															message: 'SUPI is not valid.',
														},
													})}
													className={errors.supi ? 'is-invalid' : ''}
												/>
												{errors.supi && (
													<small className="invalid-feedback d-block">
														{errors.supi.message}
													</small>
												)}
											</InputGroup>

											<InputGroup className="mb-3">
												<InputGroup.Text style={stylePadding}>
													GPSI
												</InputGroup.Text>
												<Form.Control
													id="gpsi"
													disabled={
														isEdit && state?.subscriberId == state?.gpsi
													}
													aria-label="gpsi"
													{...register('gpsi', {
														pattern: {
															value: new RegExp(REGEX.MSISDN),
															message: 'GPSI is not valid.',
														},
													})}
													className={errors.gpsi ? 'is-invalid' : ''}
												/>
												{errors.gpsi && (
													<small className="invalid-feedback d-block">
														{errors.gpsi.message}
													</small>
												)}
											</InputGroup>

											<ContactInfoForm
												onChange={handleChangeForms as never}
												activeForm={activeForm}
												data={state?.contactInfo}
												hasPlans={false}
												onIsValid={handleIsValid}
												quota_manager={quotaManagerValue}
											/>

											<DnnForm
												onChange={handleChangeForms as never}
												activeForm={activeForm}
												data={state?.smPolicySnssaiData}
												hasPlans={false}
												onIsValid={handleIsValid}
												quota_manager={quotaManagerValue}
											/>

											<HomeZoneForm
												onChange={handleChangeForms as never}
												activeForm={activeForm}
												data={state?.homeZones}
												hasPlans={false}
												onIsValid={handleIsValid}
												quota_manager={quotaManagerValue}
											/>

											<PersonalQoSForm
												onChange={handleChangeForms as never}
												activeForm={activeForm}
												data={state?.personalQos}
												hasPlans={false}
												onIsValid={handleIsValid}
												quota_manager={quotaManagerValue}
											/>

											<PersonalPCCForm
												onChange={handleChangeForms as never}
												activeForm={activeForm}
												data={state?.personalPCCs}
												hasPlans={false}
												onIsValid={handleIsValid}
												quota_manager={quotaManagerValue}
											/>

											<CustomFieldForm
												onChange={handleChangeForms as never}
												activeForm={activeForm}
												data={state?.customFields}
												hasPlans={false}
												onIsValid={handleIsValid}
												quota_manager={quotaManagerValue}
											/>

											<QuotaManagerForm
												onChange={(value: {quotaManager: string}) => {
													setQuotaManagerValue(value.quotaManager);
												}}
												activeForm={activeForm}
												data={state?.customFields}
												hasPlans={planData.length > 0}
												onIsValid={handleIsValid}
												quota_manager={quotaManagerValue}
											/>

											<Button
												disabled={
													isLoading ||
													isLoadingSubscription ||
													isLoadingUpdateSubscriptionSupi ||
													isLoadingUpdateSubscriptionGpsi ||
													!isValidForm
												}
												type="submit"
												onClick={() => setActiveForm(true)}
												className="mt-2"
												style={{color: 'white'}}>
												{isEdit ? 'Update' : 'Add'}
											</Button>
										</div>

										{/* RIGHT BOX */}
										<div className="col-xs-12 col-xl-5">
											<h2>Add plan to profile</h2>
											<InputGroup className="mb-3">
												<AsyncSelect
													cacheOptions
													loadOptions={loadOptions as never}
													getOptionLabel={(e: GetOptionLabel<Option>) => e.name}
													getOptionValue={(e: GetOptionLabel<Option>) => e.name}
													defaultOptions
													placeholder="Search plan..."
													components={{DropdownIndicator}}
													onChange={handleChangeSelectPlan as never}
													styles={{
														container: base => ({
															...base,
															flex: 1,
														}),
														control: baseStyles => ({
															...baseStyles,
															borderColor: '#ced4da',
														}),
													}}
												/>

												<Button
													disabled={
														!planSelected ||
														quotaManagerValue.includes(QuotaManager.OCS_MS)
													}
													type="button"
													variant="secondary"
													style={{color: 'white'}}
													onClick={handleModalPlanAssignation}>
													Add
												</Button>
												<Button
													disabled={
														!planData ||
														planData.length === 0 ||
														isLoadingPlanes
													}
													type="button"
													onClick={handleRequestUsageReport}
													variant="primary"
													style={{color: 'white'}}>
													<i
														className="bi-arrow-clockwise"
														title="update quota consumed"
														data-toggle="tooltip"
														data-original-title="update quota consumed"
													/>
												</Button>
											</InputGroup>

											{planData.length ? (
												planData.map((plan: CurrentDataPlan) => (
													<div
														key={plan.uid}
														className="rounded-3 text-bg-light p-2 needs-validation">
														<h1>{plan?.template || 'Title'}</h1>

														<InputGroup className="mb-3">
															<InputGroup.Text
																style={stylePadding}
																className="input-group-text col-4">
																Available Quota
															</InputGroup.Text>
															{plan?.allowedUsage?.duration === null &&
																plan?.allowedUsage?.totalVolume === null &&
																plan?.allowedUsage?.uplinkVolume === null && (
																	<>
																		<Form.Control
																			value="Available"
																			id="availableQuotaS"
																			aria-label="availableQuotaS"
																			data-tooltip-id="durationS"
																			disabled
																			className="form-control col-2"
																			style={{textAlign: 'right'}}
																		/>
																	</>
																)}
															{!!plan?.allowedUsage?.duration && (
																<>
																	<Form.Control
																		value={plan?.allowedUsage?.duration || 0}
																		id="availableQuotaDuration"
																		aria-label="availableQuotaDuration"
																		data-tooltip-id="duration"
																		disabled
																		className="form-control col-2"
																		style={{textAlign: 'right'}}
																	/>
																	<Form.Control
																		value={
																			plan?.allowedUsage?.durationUnit || 'min'
																		}
																		id="availableQuotaDurationUnit"
																		aria-label="availableQuotaDurationUnit"
																		disabled
																		className="form-control col-2"
																	/>
																</>
															)}

															{!!plan?.allowedUsage?.totalVolumeUnit && (
																<>
																	<Form.Control
																		value={formatNumber(
																			plan?.allowedUsage?.totalVolume || 0,
																		)}
																		id="availableQuotaTotalVolume"
																		aria-label="availableQuotaTotalVolume"
																		data-tooltip-id="totalVolume"
																		disabled
																		className="form-control col-2"
																		style={{textAlign: 'right'}}
																		readOnly
																	/>
																	<Form.Control
																		value={
																			plan?.allowedUsage?.totalVolumeUnit || 'b'
																		}
																		id="availableQuotaTotalVolumeUnit"
																		aria-label="availableQuotaTotalVolumeUnit"
																		disabled
																		className="form-control col-2"
																	/>
																</>
															)}

															{!!plan?.allowedUsage?.downlinkVolumeUnit && (
																<>
																	<Form.Control
																		value={formatNumber(
																			plan?.allowedUsage?.downlinkVolume || 0,
																		)}
																		id="availableQuotaDownlinkVolume"
																		aria-label="availableQuotaDownlinkVolume"
																		data-tooltip-id="downlinkVolume"
																		disabled
																		style={{textAlign: 'right'}}
																	/>
																	<Form.Control
																		value={
																			plan?.allowedUsage?.downlinkVolumeUnit ||
																			'b'
																		}
																		id="availableQuotaDownlinkVolumeUnit"
																		aria-label="availableQuotaDownlinkVolumeUnit"
																		disabled
																	/>
																</>
															)}

															{!!plan?.allowedUsage?.uplinkVolumeUnit && (
																<>
																	<Form.Control
																		value={formatNumber(
																			plan?.allowedUsage?.uplinkVolume || 0,
																		)}
																		id="availableQuotaUplinkVolume"
																		aria-label="availableQuotaUplinkVolume"
																		data-tooltip-id="uplinkVolume"
																		disabled
																		className="form-control col-2"
																		style={{textAlign: 'right'}}
																	/>
																	<Form.Control
																		value={
																			plan?.allowedUsage?.uplinkVolumeUnit ||
																			'b'
																		}
																		id="availableQuotaDownlinkVolumeUnit"
																		aria-label="availableQuotaDownlinkVolumeUnit"
																		disabled
																		className="form-control col-2"
																	/>
																</>
															)}
														</InputGroup>

														<InputGroup className="mb-3">
															<InputGroup.Text
																style={stylePadding}
																className="input-group-text col-4">
																Max Quota
															</InputGroup.Text>
															{plan?.usageThreshold?.duration === null &&
																plan?.usageThreshold?.totalVolume === null &&
																plan?.usageThreshold?.uplinkVolume === null && (
																	<>
																		<Form.Control
																			value="Unlimited"
																			id="maxQuotaDuration"
																			aria-label="maxQuotaDuration"
																			data-tooltip-id="maxDuration"
																			disabled
																			className="form-control col-2"
																			style={{textAlign: 'right'}}
																		/>
																	</>
																)}
															{!!plan?.usageThreshold?.duration && (
																<>
																	<Form.Control
																		value={plan?.usageThreshold?.duration || 0}
																		id="maxQuotaDuration"
																		aria-label="maxQuotaDuration"
																		data-tooltip-id="duration"
																		disabled
																		className="form-control col-2"
																		style={{textAlign: 'right'}}
																	/>
																	<Form.Control
																		value={
																			plan?.usageThreshold?.durationUnit ||
																			'min'
																		}
																		id="maxQuotaDurationUnit"
																		aria-label="maxQuotaDurationUnit"
																		disabled
																		className="form-control col-2"
																	/>
																</>
															)}

															{!!plan?.usageThreshold?.totalVolumeUnit && (
																<>
																	<Form.Control
																		value={formatNumber(
																			plan?.usageThreshold?.totalVolume || 0,
																		)}
																		id="maxQuotaTotalVolume"
																		aria-label="maxQuotaTotalVolume"
																		data-tooltip-id="totalVolume"
																		disabled
																		className="form-control col-2"
																		style={{textAlign: 'right'}}
																	/>
																	<Form.Control
																		value={
																			plan?.usageThreshold?.totalVolumeUnit ||
																			'b'
																		}
																		id="maxQuotaTotalVolumeUnit"
																		aria-label="maxQuotaTotalVolumeUnit"
																		disabled
																		className="form-control col-2"
																	/>
																</>
															)}

															{!!plan?.usageThreshold?.downlinkVolumeUnit && (
																<>
																	<Form.Control
																		value={formatNumber(
																			plan?.usageThreshold?.downlinkVolume || 0,
																		)}
																		id="maxQuotaDownlinkVolume"
																		aria-label="maxQuotaDownlinkVolume"
																		data-tooltip-id="downlinkVolume"
																		disabled
																		style={{textAlign: 'right'}}
																	/>
																	<Form.Control
																		value={
																			plan?.usageThreshold
																				?.downlinkVolumeUnit || ''
																		}
																		id="maxQuotaDownlinkVolumeUnit"
																		aria-label="maxQuotaDownlinkVolumeUnit"
																		disabled
																	/>
																</>
															)}

															{!!plan?.usageThreshold?.uplinkVolume && (
																<>
																	<Form.Control
																		value={formatNumber(
																			plan?.usageThreshold?.uplinkVolume || 0,
																		)}
																		id="maxQuotaUplinkVolume"
																		aria-label="maxQuotaUplinkVolume"
																		data-tooltip-id="uplinkVolume"
																		disabled
																		style={{textAlign: 'right'}}
																	/>
																	<Form.Control
																		value={
																			plan?.usageThreshold?.uplinkVolumeUnit ||
																			'b'
																		}
																		id="maxQuotaUplinkVolumeUnit"
																		aria-label="usageThresholdUplinkVolumeUnit"
																		disabled
																	/>
																</>
															)}
														</InputGroup>

														<InputGroup className="mb-3">
															<InputGroup.Text
																style={stylePadding}
																className="input-group-text col-4">
																Quota Consumed
															</InputGroup.Text>
															{plan?.useConsumed?.duration === null &&
																plan?.useConsumed?.totalVolume === null &&
																plan?.useConsumed?.uplinkVolume === null && (
																	<>
																		<Form.Control
																			value="Consumed"
																			id="consumedQuotaS"
																			aria-label="consumedQuotaS"
																			data-tooltip-id="consumedS"
																			disabled
																			className="form-control col-2"
																			style={{textAlign: 'right'}}
																		/>
																	</>
																)}
															{plan?.useConsumed?.duration !== null &&
																plan?.useConsumed?.duration !== undefined && (
																	<>
																		<Form.Control
																			value={plan?.useConsumed?.duration || 0}
																			id="consumedQuotaDuration"
																			aria-label="consumedQuotaDuration"
																			data-tooltip-id="consumedDuration"
																			disabled
																			className="form-control col-2"
																			style={{textAlign: 'right'}}
																		/>
																		<Form.Control
																			value={
																				plan?.useConsumed?.durationUnit || 'min'
																			}
																			id="consumedDurationUnit"
																			aria-label="consumedQuotaDurationUnit"
																			disabled
																			className="form-control col-2"
																		/>
																	</>
																)}

															{!!plan?.useConsumed?.totalVolumeUnit && (
																<>
																	<Form.Control
																		value={formatNumber(
																			plan?.useConsumed?.totalVolume || 0,
																		)}
																		id="consumedQuotaTotalVolume"
																		aria-label="consumedQuotaTotalVolume"
																		data-tooltip-id="totalVolume"
																		disabled
																		className="form-control col-2"
																		style={{textAlign: 'right'}}
																	/>
																	<Form.Control
																		value={
																			plan?.useConsumed?.totalVolumeUnit || 'b'
																		}
																		id="consumedQuotaTotalVolumeUnit"
																		aria-label="consumedQuotaTotalVolumeUnit"
																		disabled
																		className="form-control col-2"
																	/>
																</>
															)}

															{!!plan?.useConsumed?.downlinkVolumeUnit && (
																<>
																	<Form.Control
																		value={formatNumber(
																			plan?.useConsumed?.downlinkVolume || 0,
																		)}
																		id="consumedQuotaDownlinkVolume"
																		aria-label="consumedQuotaDownlinkVolume"
																		data-tooltip-id="consumedDownlinkVolume"
																		disabled
																		style={{textAlign: 'right'}}
																	/>
																	<Form.Control
																		value={
																			plan?.useConsumed?.downlinkVolumeUnit ||
																			''
																		}
																		id="consumedQuotaDownlinkVolumeUnit"
																		aria-label="consumedQuotaDownlinkVolumeUnit"
																		disabled
																	/>
																</>
															)}

															{!!plan?.useConsumed?.uplinkVolume && (
																<>
																	<Form.Control
																		value={formatNumber(
																			plan?.useConsumed?.uplinkVolume || 0,
																		)}
																		id="consumedQuotaUplinkVolume"
																		aria-label="consumedQuotaUplinkVolume"
																		data-tooltip-id="consumedUplinkVolume"
																		disabled
																		style={{textAlign: 'right'}}
																	/>
																	<Form.Control
																		value={
																			plan?.useConsumed?.uplinkVolumeUnit || 'b'
																		}
																		id="consumedQuotaUplinkVolumeUnit"
																		aria-label="consumedUplinkVolumeUnit"
																		disabled
																	/>
																</>
															)}
														</InputGroup>

														<div className="row">
															<InputGroup className="mb-3 col-xs-12 col-md-5">
																<InputGroup.Text style={stylePadding}>
																	Start Date
																</InputGroup.Text>
																<Form.Control
																	value={
																		plan?.notBefore
																			? format(
																					parseISO(plan.notBefore),
																					'yyyy-MM-dd HH:mm',
																			  )
																			: ''
																	}
																	id="startDate"
																	aria-label="startDate"
																	disabled
																/>
															</InputGroup>

															<InputGroup className="mb-3 col-xs-12 col-md-5">
																<InputGroup.Text style={stylePadding}>
																	End Date
																</InputGroup.Text>
																<Form.Control
																	value={
																		plan?.notAfter
																			? format(
																					parseISO(plan.notAfter),
																					'yyyy-MM-dd HH:mm',
																			  )
																			: ''
																	}
																	id="endDate"
																	aria-label="endDate"
																	disabled
																/>
															</InputGroup>
														</div>
														{Number(plan?.resetPeriod?.maxNumPeriod) !== 1 && (
															<div className="border rounded m-0 p-2 mb-3 row">
																<div className="pl-0">
																	<h6>Bill Cycle</h6>
																</div>
																<div className="row p-0">
																	<InputGroup className="mb-3 col-xs-12 col-md-6">
																		<InputGroup.Text style={stylePadding}>
																			Period
																		</InputGroup.Text>
																		<Form.Control
																			value={plan?.resetPeriod?.period}
																			disabled
																		/>
																	</InputGroup>

																	{plan?.resetPeriod && (
																		<InputGroup className="mb-3 col-xs-12 col-md-6">
																			<InputGroup.Text style={stylePadding}>
																				Remaining resets
																			</InputGroup.Text>
																			<Form.Control
																				value={
																					plan?.resetPeriod?.maxNumPeriod ===
																						null ||
																					plan?.resetPeriod?.maxNumPeriod === 0
																						? 'Unlimited'
																						: (
																								plan?.resetPeriod
																									?.maxNumPeriod - 1
																						  ).toString()
																				}
																				disabled
																			/>
																		</InputGroup>
																	)}
																</div>
																<div className="row p-0">
																	<InputGroup className="mb-3 col-xs-12 col-md-12">
																		<InputGroup.Text style={stylePadding}>
																			Next Billing Cycle
																		</InputGroup.Text>
																		<Form.Control
																			id="lastBillCycle"
																			aria-label="lastBillCycle"
																			disabled
																			value={
																				plan?.resetTime
																					? format(
																							parseISO(plan.resetTime),
																							'yyyy-MM-dd HH:mm',
																					  )
																					: ''
																			}
																		/>
																	</InputGroup>
																</div>
															</div>
														)}

														{plan?.groupPlan && (
															<div className="border rounded m-0 p-2 mb-3 row">
																<div className="pl-0">
																	<h6>Group plan</h6>
																</div>
																<div className="row p-0">
																	<InputGroup className="mb-3 col-xs-12 col-md-12">
																		<InputGroup.Text style={stylePadding}>
																			Members
																		</InputGroup.Text>
																		<Form.Control
																			value={plan?.groupMembers ?? ''}
																			disabled
																		/>
																	</InputGroup>
																</div>
															</div>
														)}

														<div className="d-flex justify-content-end mt-3">
															<Button
																className="btn btn-primary mr-1"
																disabled={isLoadingResetUsagePlan}
																onClick={() => handleResetUsagePlan(plan)}
																style={{color: 'white'}}>
																Reset Plan
															</Button>

															<Button
																className="btn btn-danger"
																disabled={isLoadingRemovePlan}
																onClick={() => handleRemove(plan)}
																style={{color: 'white'}}>
																Remove plan
															</Button>
														</div>
													</div>
												))
											) : (
												<h6 className="mt-5 text-center">Empty</h6>
											)}

											{PLAN_TOOLTIPS.map(el => (
												<ReactTooltip
													key={el.id}
													id={el.id}
													place={el.place as never}
													content={el.content}
												/>
											))}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</Form>
			</div>

			<ModalPlanAssignation
				open={openModalPlanAssignation}
				onClose={handleModalPlanAssignation}
				planSelected={planSelected as never}
				ueId={subscriberIdState}
				isSupiIdentifier={isSupiIdentifier}
				onUpdatePlanData={handleUpdatePlanData}
			/>
		</LayoutMain>
	);
};
type TProps = {
	onChange: (data: any) => void;
	activeForm: boolean;
	data: any;
	hasPlans: boolean;
	quota_manager: any;
	onIsValid: (valid: boolean) => void;
};

type FormContactInfo = {
	email: string;
	msisdn: string;
	contactInfoType: string;
};

const ContactInfoForm = ({onChange, activeForm, data, onIsValid}: TProps) => {
	const {
		control,
		register,
		formState: {errors, isValid},
		handleSubmit,
	} = useForm({
		mode: 'all',
		defaultValues: {
			contactInfo: defaultContactInfoForm(data),
		},
	});

	// eslint-disable-next-line react-hooks/exhaustive-deps
	useEffect(() => onIsValid(isValid), [isValid]);

	const {fields, append, remove} = useFieldArray({
		control,
		name: 'contactInfo',
	});

	const dataContactInfo = useWatch({control});

	const onSave = () => {};

	useEffect(() => {
		onChange(dataContactInfo);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dataContactInfo]);

	useEffect(() => {
		if (activeForm) {
			void handleSubmit(onSave)();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [activeForm]);

	const removeModal = (i: number) => ({
		title: 'Do you really want to remove?',
		message: 'This action can not be undone.',
		buttons: [
			{
				label: 'Yes',
				onClick: () => {
					try {
						remove(i);
					} catch (error) {
						console.error(error);
					}
				},
			},
			{
				label: 'No',
			},
		],
		closeOnEscape: true,
		closeOnClickOutside: true,
		keyCodeForClose: [8, 32],
		overlayClassName: 'overlay-custom-class-name',
	});

	return (
		<div className="rounded-3 text-bg-light p-2 mb-4">
			<div className="d-flex justify-content-between mb-2">
				<h2>Contact Information</h2>

				{fields.length === 0 && (
					<Button
						type="button"
						onClick={() => append(defaultContactInfoForm() as never)}
						variant="secondary"
						style={{color: 'white'}}>
						Add
					</Button>
				)}
			</div>

			<form onSubmit={handleSubmit(onSave)}>
				{fields.length ? (
					fields.map((field, i) => (
						<div key={field.id} className="row mb-3">
							<div className="d-flex justify-content-end align-items-center">
								<Button
									type="button"
									onClick={() => confirmAlert(removeModal(i))}
									variant="outline-secondary"
									style={{color: 'white'}}>
									<i
										className="bi-1 bi-trash-fill text-danger"
										title=""
										data-toggle="tooltip"
										data-original-title="Delete"
									/>
								</Button>
							</div>

							<div className="col-xs-12 col-lg-4">
								<label htmlFor="phone">Phone Number</label>
								<Form.Control
									data-tooltip-id="phone"
									id="phone"
									aria-label="phone"
									{...register(`contactInfo.${i}.msisdn`, {
										required: 'The phone number is required.',
										pattern: {
											value: /^\+?[1-9]\d{1,14}$/,
											message: 'Enter a valid phone number',
										},
									})}
									className={
										errors?.contactInfo?.[i]?.msisdn ? 'is-invalid' : ''
									}
								/>
								{errors?.contactInfo?.[i]?.msisdn && (
									<div className="invalid-feedback">
										{errors.contactInfo?.[i]?.msisdn?.message ?? ''}
									</div>
								)}
							</div>
						</div>
					))
				) : (
					<div className="d-flex justify-content-center mb-3">
						<span>Empty</span>
					</div>
				)}
			</form>
		</div>
	);
};

type FormDnn = {
	dnn: string;
	subscCats: string[];
	gbrUl: string;
	gbps: string;
	gbrDl: string;
	_gbps: string;
	online: string;
	offline: string;
	primaryAddress: string;
	secondaryAddress: string;
	limitId: string;
	monitoringKey: string;
};
const DnnForm = ({onChange, activeForm, data, onIsValid}: TProps) => {
	// validation form
	const {
		control,
		register,
		formState: {errors, isValid},
		handleSubmit,
		setValue,
	} = useForm({
		mode: 'all',
		defaultValues: {
			formDnn: defaultFormDnn(data),
			formDnnCategories: defaultFormSubCats(data),
			formDnnMonitoring: defaultFormDnnMonitoring(data),
		},
	});

	// eslint-disable-next-line react-hooks/exhaustive-deps
	useEffect(() => onIsValid(isValid), [isValid]);

	const {fields, append, remove, update} = useFieldArray({
		control,
		name: 'formDnn',
	});

	const {
		fields: fieldsCategories,
		append: appendCategories,
		remove: removeCategories,
		update: updateCategories,
	} = useFieldArray({
		control,
		name: 'formDnnCategories',
	});

	const {
		fields: refUmdLimitIds,
		append: appendMonitoring,
		remove: removeMonitoring,
		update: updateMonitoring,
	} = useFieldArray({
		control,
		name: 'formDnnMonitoring',
	});

	const dataFormDnn = useWatch({control});

	const onSave = () => {};

	useEffect(() => {
		onChange(dataFormDnn);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dataFormDnn]);

	useEffect(() => {
		if (activeForm) {
			void handleSubmit(onSave)();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [activeForm]);

	const removeModal = (i: number, index: number, type: string) => ({
		title: 'Do you really want to remove?',
		message: 'The change is not saved until you click on Update button.',
		buttons: [
			{
				label: 'Yes',
				onClick: () => {
					try {
						switch (type) {
							case 'basic':
								remove(i);
								break;
							case 'category':
								const fieldSubsCaps = dataFormDnn?.formDnn?.[
									i
								].subscCats?.filter(
									(element: string, categoryIdx: number) =>
										categoryIdx !== index,
								);
								update(i, {...fields[i], subscCats: fieldSubsCaps});
								setValue('formDnnCategories', fieldSubsCaps);
								break;
							case 'monitoring':
								const fieldRefUmdLimitId = dataFormDnn?.formDnn?.[
									i
								].refUmdLimitIds.filter(
									(element: string, refUmdLimitIndex: number) =>
										refUmdLimitIndex !== index,
								);
								update(i, {...fields[i], refUmdLimitIds: fieldRefUmdLimitId});
								setValue('formDnnMonitoring', fieldRefUmdLimitId);
								break;
							default:
								break;
						}
					} catch (error) {
						console.error(error);
					}
				},
			},
			{
				label: 'No',
			},
		],
		closeOnEscape: true,
		closeOnClickOutside: true,
		keyCodeForClose: [8, 32],
		overlayClassName: 'overlay-custom-class-name',
	});

	const handleCategoryChange = (idxFormDnn: number, idxSubsCat: number) => {
		const valueFormDnn =
			dataFormDnn?.formDnn?.[idxFormDnn].subscCats?.[idxSubsCat];
		updateCategories(idxSubsCat, valueFormDnn);
	};

	const handleRefUmdLimitIdChange = (
		idxFormDnn: number,
		idxRefUmdLimitId: number,
	) => {
		const valueFormDnn =
			dataFormDnn?.formDnn?.[idxFormDnn].refUmdLimitIds?.[idxRefUmdLimitId];
		updateMonitoring(idxRefUmdLimitId, valueFormDnn);
	};

	return (
		<div className="rounded-3 text-bg-light p-2 mb-4">
			<div className="d-flex justify-content-between mb-2">
				<h2>Session Management Policy Data per DNN</h2>

				<Button
					type="button"
					onClick={() => append(defaultFormDnn() as never)}
					variant="secondary"
					style={{color: 'white'}}>
					Add
				</Button>
			</div>

			<div onSubmit={handleSubmit(onSave)}>
				{fields.length ? (
					fields.map((field, i) => (
						<div key={field.id} className="mb-5">
							<div className="d-flex justify-content-end align-items-center">
								<Button
									type="button"
									onClick={() => confirmAlert(removeModal(i, 0, 'basic'))}
									variant="outline-secondary"
									style={{color: 'white'}}>
									<i
										className="bi-1 bi-trash-fill text-danger"
										title=""
										data-toggle="tooltip"
										data-original-title="Delete"
									/>
								</Button>
							</div>
							<div className="row d-flex justify-content-between">
								<div className="col-xs-12 col-lg-4 mb-4">
									<label htmlFor="DNN" className="font-weight-bold">
										DNN
									</label>
									<Form.Control
										data-tooltip-id="dnn"
										id="dnn"
										aria-label="dnn"
										placeholder="*"
										{...register(`formDnn.${i}.dnn`, {
											required: 'The DNN is required. * is an accepted value.',
											pattern: {
												value: /^(?!\s*$)[A-Za-z0-9\-_\.\*]+$/g,
												message:
													'DNN is not valid. Accepts alphanumerics, . and *',
											},
										})}
										className={
											errors?.formDnn?.[i]?.dnn?.message ? 'is-invalid' : ''
										}
									/>
									{errors?.formDnn?.[i]?.dnn?.message && (
										<small className="invalid-feedback d-block">
											{String(errors?.formDnn?.[i]?.dnn?.message)}
										</small>
									)}
								</div>
							</div>

							<div className="d-flex justify-content-between">
								<label htmlFor="" className="font-weight-bold">
									Categories
								</label>

								<Button
									type="button"
									onClick={() => appendCategories('')}
									variant="secondary"
									style={{color: 'white'}}>
									Add
								</Button>
							</div>
							{fieldsCategories.length ? (
								fieldsCategories.map((fieldCategory, idx) => (
									<div key={fieldCategory.id} className="row">
										<div className="col-xs-12 col-lg-6 mb-4">
											<Form.Control
												data-tooltip-id="subscCats"
												id="subscCats"
												aria-label="subscCats"
												{...register(`formDnn.${i}.subscCats.${idx}`, {
													required: false,
													pattern: {
														value: /^(?!\s*$)[A-Za-z0-9\s\-_]+$/g,
														message:
															'Category is not valid. Accepts alphanumerics, spaces, ., -, _ and *',
													},
													onBlur: () => handleCategoryChange(i, idx),
												})}
												className={
													(errors?.formDnn?.[i]?.subscCats as any)?.[idx]
														?.message
														? 'is-invalid'
														: ''
												}
											/>
											{(errors?.formDnn?.[i]?.subscCats as any)?.[idx]
												?.message && (
												<small className="invalid-feedback d-block">
													{
														(errors?.formDnn?.[i]?.subscCats as any)?.[idx]
															?.message
													}
												</small>
											)}
										</div>

										<div className="col-xs-12 col-lg-4 mb-4">
											<Button
												type="button"
												onClick={() =>
													confirmAlert(removeModal(i, idx, 'category'))
												}
												variant="outline-secondary"
												style={{color: 'white'}}>
												<i
													className="bi-1 bi-trash-fill text-danger"
													title=""
													data-toggle="tooltip"
													data-original-title="Delete"
												/>
											</Button>
										</div>
									</div>
								))
							) : (
								<div className="d-flex justify-content-center mb-3">
									<span>Empty</span>
								</div>
							)}

							<label htmlFor="gbrUl" className="font-weight-bold">
								Bit Rate
							</label>
							<div className="d-flex">
								<div className="mr-3">
									<label htmlFor="gbrUl">Gbr UL</label>
									<div className="d-flex">
										<Form.Control
											data-tooltip-id="gbrUl"
											id="gbrUl"
											aria-label="gbrUl"
											placeholder="0"
											{...register(`formDnn.${i}.gbrUl`, {
												required: false,
												pattern: {
													value: /^\d+(\.\d+)?/g,
													message: 'gbrUl must be a number.',
												},
											})}
											className={
												(errors?.formDnn as any)?.[i]?.gbrUl?.message
													? 'is-invalid'
													: ''
											}
										/>
										<Form.Select
											data-tooltip-id="prio"
											aria-label="gbps"
											className={
												(errors?.formDnn as any)?.[i]?.gbps?.message
													? 'is-invalid'
													: ''
											}
											{...register(`formDnn.${i}.gbps`, {
												required: false,
												pattern: {
													value: /^[A-Za-z\s]+$/g,
													message: 'gbps is not valid.',
												},
											})}>
											<option disabled value="">
												Select option
											</option>
											<option value="bps">bps</option>
											<option value="Kbps">Kbps</option>
											<option value="Mbps">Mbps</option>
											<option value="Gbps">Gbps</option>
											<option value="Tbps">Tbps</option>
										</Form.Select>
									</div>
									{errors?.formDnn?.[i]?.gbrUl?.message && (
										<small className="invalid-feedback d-block">
											{String(errors?.formDnn?.[i]?.gbrUl?.message)}
										</small>
									)}
								</div>

								<div className="ml-3">
									<label htmlFor="gbrDl">Gbr DL</label>
									<div className="d-flex">
										<Form.Control
											data-tooltip-id="gbrDl"
											id="gbrDl"
											aria-label="gbrDl"
											placeholder="0"
											{...register(`formDnn.${i}.gbrDl`, {
												required: false,
												pattern: {
													value: /^\d+(\.\d+)?/g,
													message: 'gbrDl must be a number.',
												},
											})}
											className={
												(errors?.formDnn as any)?.[i]?.gbrDl?.message
													? 'is-invalid'
													: ''
											}
										/>
										<Form.Select
											data-tooltip-id="prio"
											aria-label="_gbps"
											className={
												(errors?.formDnn as any)?.[i]?._gbps?.message
													? 'is-invalid'
													: ''
											}
											{...register(`formDnn.${i}._gbps`, {
												required: false,
												pattern: {
													value: /^[A-Za-z0-9\s]+$/g,
													message: 'gbps is not valid.',
												},
											})}>
											<option disabled value="">
												Select option
											</option>
											<option value="bps">bps</option>
											<option value="Kbps">Kbps</option>
											<option value="Mbps">Mbps</option>
											<option value="Gbps">Gbps</option>
											<option value="Tbps">Tbps</option>
										</Form.Select>
									</div>
									{errors?.formDnn?.[i]?.gbrDl?.message && (
										<small className="invalid-feedback d-block">
											{String(errors?.formDnn?.[i]?.gbrDl?.message)}
										</small>
									)}
								</div>
							</div>

							<label htmlFor="Online" className="mt-4 font-weight-bold">
								Charging Information
							</label>
							<div className="row">
								<div className="col-xs-12 col-lg-3 mb-4">
									<label htmlFor="online">Online</label>
									<Form.Select
										aria-label="Online"
										{...register(`formDnn.${i}.online`, {
											required: false,
										})}>
										<option value="blank" />
										<option value="true">True</option>
										<option value="false">False</option>
									</Form.Select>
								</div>
								<div className="col-xs-12 col-lg-3 mb-4">
									<label htmlFor="offline">Offline</label>
									<Form.Select
										aria-label="Offline"
										{...register(`formDnn.${i}.offline`, {
											required: false,
										})}>
										<option value="blank" />
										<option value="true">True</option>
										<option value="false">False</option>
									</Form.Select>
								</div>
							</div>

							<div className="row">
								<div className="col-xs-12 col-lg-6 mb-4">
									<label htmlFor="Primary Address">Primary Address</label>
									<Form.Control
										data-tooltip-id="Primary Address"
										id="Primary Address"
										aria-label="Primary Address"
										{...register(`formDnn.${i}.primaryAddress`, {
											required: false,
											pattern: {
												value: /^(?!\s*$)[A-Za-z0-9.\-:]+$/g,
												message: 'Primary Address must be an IP or a realm.',
											},
										})}
										className={
											errors?.formDnn?.[i]?.primaryAddress?.message
												? 'is-invalid mb-2'
												: 'mb-2'
										}
									/>
									{errors?.formDnn?.[i]?.primaryAddress?.message && (
										<small className="invalid-feedback d-block">
											{String(errors?.formDnn?.[i]?.primaryAddress?.message)}
										</small>
									)}
								</div>
								<div className="col-xs-12 col-lg-6 mb-4">
									<label htmlFor="Secondary Address">Secondary Address</label>
									<Form.Control
										data-tooltip-id="Secondary Address"
										id="Secondary Address"
										aria-label="Secondary Address"
										{...register(`formDnn.${i}.secondaryAddress`, {
											required: false,
											pattern: {
												value: /^(?!\s*$)[A-Za-z0-9.\-:]+$/g,
												message: 'Secondary Address must be an IP or a realm.',
											},
										})}
										className={
											errors?.formDnn?.[i]?.secondaryAddress?.message
												? 'is-invalid mb-2'
												: 'mb-2'
										}
									/>
									{errors?.formDnn?.[i]?.secondaryAddress?.message && (
										<small className="invalid-feedback d-block">
											{String(errors?.formDnn?.[i]?.secondaryAddress?.message)}
										</small>
									)}
								</div>
							</div>

							<div className="d-flex justify-content-between">
								<label htmlFor="" className="font-weight-bold">
									Usage Monitoring
								</label>

								<Button
									type="button"
									onClick={() =>
										appendMonitoring({
											limitId: '',
											monitoringKey: '',
										})
									}
									variant="secondary"
									style={{color: 'white'}}>
									Add
								</Button>
							</div>

							{refUmdLimitIds.length ? (
								refUmdLimitIds.map((fieldRefUmdLimitId, idx) => (
									<div key={fieldRefUmdLimitId.id} className="row">
										<div className="col-xs-12 col-lg-5">
											<label htmlFor="Limit Id">Limit Id</label>
											<Form.Control
												data-tooltip-id="Limit Id"
												id="Limit Id"
												aria-label="Limit Id"
												placeholder="*"
												{...register(
													`formDnn.${i}.refUmdLimitIds.${idx}.limitId`,
													{
														required: false,
														pattern: {
															value: /^[A-Za-z0-9\s]+$|^$/g,
															message: 'limitId is not valid.',
														},
														onBlur: () => handleRefUmdLimitIdChange(i, idx),
													},
												)}
												className={'mb-2'}
											/>
										</div>

										<div className="col-xs-12 col-lg-5">
											<label htmlFor="Limit Id">Monitoring Key</label>
											<Form.Control
												data-tooltip-id="Limit Id"
												id="Limit Id"
												aria-label="Limit Id"
												placeholder="*"
												{...register(
													`formDnn.${i}.refUmdLimitIds.${idx}.monitoringKey`,
													{
														required: false,
														pattern: {
															value: /^[A-Za-z0-9\s]+$|^$/g,
															message: 'monitoringKey is not valid.',
														},
														onBlur: () => handleRefUmdLimitIdChange(i, idx),
													},
												)}
												className={'mb-2'}
											/>
										</div>

										<div className="col-xs-12 col-lg-2 mt-3 d-flex justify-content-center align-items-center">
											<Button
												type="button"
												onClick={() =>
													confirmAlert(removeModal(i, idx, 'monitoring'))
												}
												variant="outline-secondary"
												style={{color: 'white'}}>
												<i
													className="bi-1 bi-trash-fill text-danger"
													title=""
													data-toggle="tooltip"
													data-original-title="Delete"
												/>
											</Button>
										</div>
									</div>
								))
							) : (
								<div className="d-flex justify-content-center mb-3">
									<span>Empty</span>
								</div>
							)}
						</div>
					))
				) : (
					<div className="d-flex justify-content-center mb-3">
						<span>Empty</span>
					</div>
				)}

				{PCC_TOOLTIPS.map(el => (
					<ReactTooltip
						key={el.id}
						id={el.id}
						place={el.place as never}
						content={el.content}
					/>
				))}
			</div>
		</div>
	);
};
type FormDataHomeZone = {
	mcc: string;
	mnc: string;
	tac: string;
	eci: string;
	lac: string;
	sac: string;
	typeULI: number;
};
const HomeZoneForm = ({onChange, activeForm, data, onIsValid}: TProps) => {
	// validation form
	const {
		control,
		trigger,
		register,
		formState: {errors, isValid},
		handleSubmit,
	} = useForm({
		mode: 'all',
		defaultValues: {
			homeZones: defaultDataHomeZone(data),
		},
	});

	// eslint-disable-next-line react-hooks/exhaustive-deps
	useEffect(() => onIsValid(isValid), [isValid]);

	const {fields, append, remove, update} = useFieldArray({
		control,
		name: 'homeZones',
	});
	const dataHomeZone = useWatch({control});

	const onSave = () => {};

	useEffect(() => {
		onChange(dataHomeZone);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dataHomeZone]);

	useEffect(() => {
		if (activeForm) {
			void handleSubmit(onSave)();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [activeForm]);

	const removeModal = (i: number) => ({
		title: 'Do you really want to remove?',
		message: 'The change is not saved until you click on Update button.',
		buttons: [
			{
				label: 'Yes',
				onClick: () => {
					try {
						remove(i);
					} catch (error) {
						console.error(error);
					}
				},
			},
			{
				label: 'No',
			},
		],
		closeOnEscape: true,
		closeOnClickOutside: true,
		keyCodeForClose: [8, 32],
		overlayClassName: 'overlay-custom-class-name',
	});

	const changeULI = async (
		idxUli: number,
		event: React.ChangeEvent<HTMLSelectElement>,
	) => {
		const codeULI = event.target.value;
		update(idxUli, {
			...fields[idxUli],
			typeULI: event.target.value,
			tac: '',
			sac: '',
			eci: '',
			lac: '',
		});
		await trigger(`homeZones.${idxUli}.typeULI`);
	};

	return (
		<div className="rounded-3 text-bg-light p-2 mb-4">
			<div className="d-flex justify-content-between mb-4">
				<h2>Home Zones</h2>

				<Button
					type="button"
					onClick={() => append(defaultDataHomeZone() as never)}
					variant="secondary"
					style={{color: 'white'}}>
					Add
				</Button>
			</div>
			<div onSubmit={handleSubmit(onSave)}>
				{fields.length ? (
					fields.map((field, i) => (
						<div key={field.id} className="mb-3 pl-2 pr-2 bg-gray">
							<div className="d-flex justify-content-end align-items-center pt-2">
								<Button
									type="button"
									onClick={() => confirmAlert(removeModal(i))}
									variant="outline-secondary"
									style={{color: 'white'}}>
									<i
										className="bi-1 bi-trash-fill text-danger"
										title=""
										data-toggle="tooltip"
										data-original-title="Delete"
									/>
								</Button>
							</div>
							<div className="row d-flex justify-content-between">
								<div className="col-xs-12 col-lg-4 mb-4">
									<label htmlFor="tipo" className="font-weight-bold">
										Select ULI type
									</label>
									<Form.Select
										id="tipo"
										aria-label="Default select example"
										{...register(`homeZones.${i}.typeULI`, {
											required: 'You must select a ULI type.',
										})}
										className={
											(errors?.homeZones as any)?.[i]?.typeULI?.message
												? 'is-invalid'
												: ''
										}
										value={dataHomeZone?.homeZones?.[i]?.typeULI}
										onChange={e => changeULI(i, e)}>
										<option value="" disabled selected>
											Select your option
										</option>
										<option value="128">TAI</option>
										<option value="129">ECGI</option>
										<option value="130">TAI - ECGI</option>
										<option value="1">SAI</option>
									</Form.Select>
									{(errors?.homeZones as any)?.[i]?.typeULI && (
										<small className="invalid-feedback d-block">
											{(errors?.homeZones as any)?.[i]?.typeULI?.message}
										</small>
									)}
								</div>
							</div>

							<div className="row">
								{dataHomeZone?.homeZones &&
									dataHomeZone?.homeZones?.[i]?.typeULI && (
										<>
											<div className="col-xs-12 col-lg-3 mb-4">
												<label htmlFor="mcc" style={stylePadding}>
													MCC
												</label>
												<Form.Control
													data-tooltip-id="mcc"
													id="mcc"
													aria-label="mcc"
													placeholder="001"
													{...register(`homeZones.${i}.mcc`, {
														required: false,
														pattern: {
															value: /^\d{3}$/g,
															message: 'MCC is not valid.',
														},
													})}
													className={
														(errors?.homeZones as any)?.[i]?.mcc?.message
															? 'is-invalid'
															: ''
													}
												/>
											</div>
											<div className="col-xs-12 col-lg-3 mb-4">
												<label htmlFor="mnc" style={stylePadding}>
													MNC
												</label>
												<Form.Control
													data-tooltip-id="mnc"
													id="mnc"
													aria-label="mnc"
													placeholder="010"
													{...register(`homeZones.${i}.mnc`, {
														required: false,
														pattern: {
															value: /^\d{2,3}$/g,
															message: 'MNC is not valid.',
														},
													})}
													className={
														(errors?.homeZones as any)?.[i]?.mnc?.message
															? 'is-invalid'
															: ''
													}
												/>
											</div>
										</>
									)}

								{dataHomeZone?.homeZones &&
									dataHomeZone?.homeZones?.[i]?.typeULI &&
									dataHomeZone?.homeZones?.[i]?.typeULI !== '1' &&
									dataHomeZone?.homeZones?.[i]?.typeULI !== '129' && (
										<>
											<div className="col-xs-12 col-lg-3 mb-4">
												<label htmlFor="tac" style={stylePadding}>
													TAC
												</label>
												<Form.Control
													data-tooltip-id="tac"
													id="tac"
													aria-label="tac"
													placeholder="0000"
													{...register(`homeZones.${i}.tac`, {
														required: false,
														pattern: {
															value: /(^[A-Fa-f0-9]{4}$)|(^[A-Fa-f0-9]{6}$)/g,
															message:
																'TAC is not valid. Must be hexadecimal of size 4',
														},
													})}
													className={
														(errors?.homeZones as any)?.[i]?.tac?.message
															? 'is-invalid'
															: ''
													}
												/>
											</div>
										</>
									)}

								{dataHomeZone?.homeZones &&
									dataHomeZone?.homeZones?.[i]?.typeULI &&
									dataHomeZone?.homeZones?.[i]?.typeULI !== '128' &&
									dataHomeZone?.homeZones?.[i]?.typeULI !== '1' && (
										<>
											<div className="col-xs-12 col-lg-3 mb-4">
												<label htmlFor="eci" style={stylePadding}>
													ECI
												</label>
												<Form.Control
													data-tooltip-id="eci"
													id="eci"
													aria-label="eci"
													placeholder="0000000"
													{...register(`homeZones.${i}.eci`, {
														required: false,
														pattern: {
															value: /^[A-Fa-f0-9]{0,7}$/g,
															message: 'ECI is not valid.',
														},
													})}
													className={
														(errors?.homeZones as any)?.[0]?.eci?.message
															? 'is-invalid'
															: ''
													}
												/>
											</div>
										</>
									)}

								{dataHomeZone?.homeZones &&
									dataHomeZone?.homeZones?.[i]?.typeULI &&
									dataHomeZone?.homeZones?.[i]?.typeULI === '1' && (
										<>
											<div className="col-xs-12 col-lg-3 mb-4">
												<label htmlFor="lac" style={stylePadding}>
													LAC
												</label>
												<Form.Control
													data-tooltip-id="lac"
													id="lac"
													aria-label="lac"
													placeholder="0000"
													{...register(`homeZones.${i}.lac`, {
														required: false,
														pattern: {
															value: /(^[A-Fa-f0-9]{4}$)|(^[A-Fa-f0-9]{6}$)/g,
															message:
																'LAC is not valid. Must be hexadecimal of size 4',
														},
													})}
													className={
														(errors?.homeZones as any)?.[i]?.lac?.message
															? 'is-invalid'
															: ''
													}
												/>
											</div>
											<div className="col-xs-12 col-lg-3 mb-4">
												<label htmlFor="sac" style={stylePadding}>
													SAC
												</label>
												<Form.Control
													data-tooltip-id="sac"
													id="sac"
													aria-label="sac"
													placeholder="0000"
													{...register(`homeZones.${i}.sac`, {
														required: false,
														pattern: {
															value: /(^[A-Fa-f0-9]{4}$)|(^[A-Fa-f0-9]{6}$)/g,
															message:
																'SAC is not valid. Must be hexadecimal of size 4',
														},
													})}
													className={
														(errors?.homeZones as any)?.[i]?.sac?.message
															? 'is-invalid'
															: ''
													}
												/>
											</div>
										</>
									)}
							</div>
						</div>
					))
				) : (
					<div className="d-flex justify-content-center mb-3">
						<span>Empty</span>
					</div>
				)}

				{HOMEZONE_TOOLTIPS.map(el => (
					<ReactTooltip
						key={el.id}
						id={el.id}
						place={el.place as never}
						content={el.content}
					/>
				))}
			</div>
		</div>
	);
};

type FormPersonalQoS = {
	dnn: string;
	_5qi: string;
	maxUlValue: string;
	maxUlUnit: string;
	maxDlValue: string;
	maxDlUnit: string;
	gbrUlValue: string;
	gbrUlUnit: string;
	gbrDlValue: string;
	gbrDlUnit: string;
	prio: string;
	vuln: string;
	cap: string;
};
const PersonalQoSForm = ({onChange, activeForm, data, onIsValid}: TProps) => {
	const {
		control,
		register,
		formState: {errors, isValid},
		handleSubmit,
	} = useForm({
		mode: 'all',
		defaultValues: {
			personalQos: defaultPersonalQoS(data),
		},
	});

	const [isMaxUlUnitEnabled, setIsMaxUlUnitEnabled] = useState(false);
	const [isMaxDlUnitEnabled, setIsMaxDlUnitEnabled] = useState(false);
	const [isGbrDlUnitEnabled, setIsGbrDlUnitEnabled] = useState(false);
	const [isGbrUlUnitEnabled, setIsGbrUlUnitEnabled] = useState(false);

	// eslint-disable-next-line react-hooks/exhaustive-deps
	useEffect(() => onIsValid(isValid), [isValid]);

	const {fields, append, remove} = useFieldArray({
		control,
		name: 'personalQos',
	});
	const dataPersonalQoS = useWatch({control});

	const onSave = () => {};

	useEffect(() => {
		onChange(dataPersonalQoS);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dataPersonalQoS]);

	useEffect(() => {
		if (activeForm) {
			void handleSubmit(onSave)();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [activeForm]);

	const removeModal = (i: number) => ({
		title: 'Do you really want to remove?',
		message: 'This action can not be undone.',
		buttons: [
			{
				label: 'Yes',
				onClick: () => {
					try {
						remove(i);
					} catch (error) {
						console.error(error);
					}
				},
			},
			{
				label: 'No',
			},
		],
		closeOnEscape: true,
		closeOnClickOutside: true,
		keyCodeForClose: [8, 32],
		overlayClassName: 'overlay-custom-class-name',
	});

	return (
		<div className="rounded-3 text-bg-light p-2 mb-4">
			<div className="d-flex justify-content-between mb-2">
				<h2>Personal QoS</h2>

				<Button
					type="button"
					onClick={() => append(defaultPersonalQoS() as never)}
					variant="secondary"
					style={{color: 'white'}}>
					Add
				</Button>
			</div>

			<div onSubmit={handleSubmit(onSave)}>
				{fields.length ? (
					fields.map((field, i) => (
						<div key={field.id} className="mb-3 pl-2 pr-2 bg-gray">
							<div className="d-flex justify-content-end align-items-center pt-2">
								<Button
									type="button"
									onClick={() => confirmAlert(removeModal(i))}
									variant="outline-secondary"
									style={{color: 'white'}}>
									<i
										className="bi-1 bi-trash-fill text-danger"
										title=""
										data-toggle="tooltip"
										data-original-title="Delete"
									/>
								</Button>
							</div>
							<div className="row d-flex justify-content-between">
								<div className="col-xs-12 col-lg-4 mb-4">
									<label htmlFor="dnn">DNN</label>
									<Form.Control
										data-tooltip-id="dnn"
										id="dnn"
										aria-label="dnn"
										placeholder="*"
										{...register(`personalQos.${i}.dnn`, {
											required: 'The DNN is required. * is an accepted value.',
											pattern: {
												value: /^(?!\s*$)[A-Za-z0-9\-_\.\*]+$/g,
												message:
													'DNN is not valid. Accepts alphanumerics, . and *',
											},
										})}
										className={
											errors?.personalQos?.[i]?.dnn?.message ? 'is-invalid' : ''
										}
									/>
									{errors?.personalQos?.[i]?.dnn?.message && (
										<small className="invalid-feedback d-block">
											{String(errors?.personalQos?.[i]?.dnn?.message)}
										</small>
									)}
								</div>

								<div className="col-xs-12 col-lg-4">
									<label htmlFor="_5qi">5QI</label>
									<Form.Control
										data-tooltip-id="_5qi"
										id="_5qi"
										aria-label="_5qi"
										placeholder="_5qi"
										{...register(`personalQos.${i}._5qi`, {
											required: false,
											pattern: {
												value: /^\d*[1-9]\d*$/,
												message: '5QI must be a positive integer.',
											},
										})}
										className={
											(errors?.personalQos as any)?.[i]?._5qi?.message
												? 'is-invalid'
												: ''
										}
									/>
									{errors?.personalQos?.[i]?._5qi?.message && (
										<small className="invalid-feedback d-block">
											{String(errors?.personalQos?.[i]?._5qi?.message)}
										</small>
									)}
								</div>

								<div className="col-xs-12 col-lg-4">
									<label htmlFor="maxUlValue">Max Uplink</label>
									<div className="d-flex">
										<Form.Control
											data-tooltip-id="maxUlValue"
											id="maxUlValue"
											aria-label="maxUlValue"
											placeholder="0"
											{...register(`personalQos.${i}.maxUlValue`, {
												required: false,
												pattern: {
													value: /^\d+(\.\d+)?/g,
													message: 'Max UL must be a positive integer.',
												},
											})}
											className={
												(errors?.personalQos as any)?.[i]?.maxUlValue?.message
													? 'is-invalid'
													: ''
											}
											onChange={e => {
												setIsMaxUlUnitEnabled(!!e.target.value);
											}}
										/>
										<Form.Select
											data-tooltip-id="prio"
											aria-label="gbps"
											className={
												(errors?.personalQos as any)?.[i]?.gbps?.message
													? 'is-invalid'
													: ''
											}
											{...register(`personalQos.${i}.maxUlUnit`, {
												required: isMaxUlUnitEnabled,
												pattern: {
													value: /^[A-Za-z\s]+$/g,
													message: 'gbps is not valid.',
												},
											})}>
											<option disabled value="">
												Select option
											</option>
											<option value="bps">bps</option>
											<option value="Kbps">Kbps</option>
											<option value="Mbps">Mbps</option>
											<option value="Gbps">Gbps</option>
											<option value="Tbps">Tbps</option>
										</Form.Select>
									</div>
									{errors?.personalQos?.[i]?.maxUlValue?.message && (
										<small className="invalid-feedback d-block">
											{String(errors?.personalQos?.[i]?.maxUlValue?.message)}
										</small>
									)}
								</div>
							</div>

							<div className="row d-flex justify-content-between">
								<div className="col-xs-12 col-lg-4 mb-4">
									<label htmlFor="maxDlValue">Max Downlink</label>
									<div className="d-flex">
										<Form.Control
											data-tooltip-id="maxDlValue"
											id="maxDlValue"
											aria-label="maxDlValue"
											placeholder="0"
											{...register(`personalQos.${i}.maxDlValue`, {
												required: false,
												pattern: {
													value: /^\d+(\.\d+)?/g,
													message: 'MaxDL is not valid.',
												},
											})}
											className={
												(errors?.personalQos as any)?.[i]?.maxDlValue?.message
													? 'is-invalid'
													: ''
											}
											onChange={e => {
												setIsMaxDlUnitEnabled(!!e.target.value);
											}}
										/>
										<Form.Select
											data-tooltip-id="prio"
											aria-label="maxDlUnit"
											className={
												(errors?.personalQos as any)?.[i]?.maxDlUnit?.message
													? 'is-invalid'
													: ''
											}
											{...register(`personalQos.${i}.maxDlUnit`, {
												required: isMaxDlUnitEnabled,
												pattern: {
													value: /^[A-Za-z0-9\s]+$/g,
													message: 'gbps is not valid.',
												},
											})}>
											<option disabled value="">
												Select option
											</option>
											<option value="bps">bps</option>
											<option value="Kbps">Kbps</option>
											<option value="Mbps">Mbps</option>
											<option value="Gbps">Gbps</option>
											<option value="Tbps">Tbps</option>
										</Form.Select>
									</div>
									{errors?.personalQos?.[i]?.maxDlValue?.message && (
										<small className="invalid-feedback d-block">
											{String(errors?.personalQos?.[i]?.maxDlValue?.message)}
										</small>
									)}
								</div>

								<div className="col-xs-12 col-lg-4">
									<label htmlFor="gbrDlValue">GrantedBr DL</label>
									<div className="d-flex">
										<Form.Control
											data-tooltip-id="gbrDlValue"
											id="gbrDlValue"
											aria-label="gbrDlValue"
											placeholder="0"
											{...register(`personalQos.${i}.gbrDlValue`, {
												required: false,
												pattern: {
													value: /^\d+(\.\d+)?/g,
													message: 'GbrDL is not valid.',
												},
											})}
											className={
												(errors?.personalQos as any)?.[i]?.gbrDlValue?.message
													? 'is-invalid'
													: ''
											}
											onChange={e => {
												setIsGbrDlUnitEnabled(!!e.target.value);
											}}
										/>
										<Form.Select
											data-tooltip-id="gbrDlUnit"
											aria-label="gbrDlUnit"
											className={
												(errors?.personalQos as any)?.[i]?.gbrDlUnit?.message
													? 'is-invalid'
													: ''
											}
											{...register(`personalQos.${i}.gbrDlUnit`, {
												required: isGbrDlUnitEnabled,
												pattern: {
													value: /^[A-Za-z0-9\s]+$/g,
													message: 'gbps is not valid.',
												},
											})}>
											<option disabled value="">
												Select option
											</option>
											<option value="bps">bps</option>
											<option value="Kbps">Kbps</option>
											<option value="Mbps">Mbps</option>
											<option value="Gbps">Gbps</option>
											<option value="Tbps">Tbps</option>
										</Form.Select>
									</div>
									{errors?.personalQos?.[i]?.gbrDlValue?.message && (
										<small className="invalid-feedback d-block">
											{String(errors?.personalQos?.[i]?.gbrDlValue?.message)}
										</small>
									)}
								</div>

								<div className="col-xs-12 col-lg-4">
									<label htmlFor="gbrUlValue">GrantedBr UL</label>
									<div className="d-flex">
										<Form.Control
											data-tooltip-id="gbrUlValue"
											id="gbrUlValue"
											aria-label="gbrUlValue"
											placeholder="0"
											{...register(`personalQos.${i}.gbrUlValue`, {
												required: false,
												pattern: {
													value: /^\d+(\.\d+)?/g,
													message: 'GbrUL is not valid.',
												},
											})}
											className={
												(errors?.personalQos as any)?.[i]?.gbrUlValue?.message
													? 'is-invalid'
													: ''
											}
											onChange={e => {
												setIsGbrUlUnitEnabled(!!e.target.value);
											}}
										/>
										<Form.Select
											data-tooltip-id="gbrUlUnit"
											aria-label="gbrUlUnit"
											className={
												(errors?.personalQos as any)?.[i]?.gbrUlUnit?.message
													? 'is-invalid'
													: ''
											}
											{...register(`personalQos.${i}.gbrUlUnit`, {
												required: isGbrUlUnitEnabled,
												pattern: {
													value: /^[A-Za-z0-9\s]+$/g,
													message: 'gbps is not valid.',
												},
											})}>
											<option disabled value="">
												Select option
											</option>
											<option value="bps">bps</option>
											<option value="Kbps">Kbps</option>
											<option value="Mbps">Mbps</option>
											<option value="Gbps">Gbps</option>
											<option value="Tbps">Tbps</option>
										</Form.Select>
									</div>
									{errors?.personalQos?.[i]?.gbrUlValue?.message && (
										<small className="invalid-feedback d-block">
											{String(errors?.personalQos?.[i]?.gbrUlValue?.message)}
										</small>
									)}
								</div>
							</div>

							<div className="row d-flex justify-content-between">
								<div className="col-xs-12 col-lg-4 mb-4">
									<label htmlFor="prio">Priority Level</label>
									<Form.Select
										data-tooltip-id="prio"
										id="prio"
										aria-label="prio"
										className={
											(errors?.personalQos as any)?.[i]?.prio?.message
												? 'is-invalid'
												: ''
										}
										{...register(`personalQos.${i}.prio`, {
											required: false,
										})}>
										<option disabled value="">
											Select option
										</option>
										<option value={1}>1</option>
										<option value={2}>2</option>
										<option value={3}>3</option>
										<option value={4}>4</option>
										<option value={5}>5</option>
										<option value={6}>6</option>
										<option value={7}>7</option>
										<option value={8}>8</option>
										<option value={9}>9</option>
										<option value={10}>10</option>
										<option value={11}>11</option>
										<option value={12}>12</option>
										<option value={13}>13</option>
										<option value={14}>14</option>
										<option value={15}>15</option>
									</Form.Select>
								</div>

								<div className="col-xs-12 col-lg-4 mt-4">
									<Form.Check
										aria-label="Pre-emption Vulnerability"
										label="Pre-emption Vulnerability"
										{...register(`personalQos.${i}.vuln`, {
											required: false,
										})}
									/>
								</div>

								<div className="col-xs-12 col-lg-4 mt-4">
									<Form.Check
										aria-label="Pre-emption Capability"
										label="Pre-emption Capability"
										{...register(`personalQos.${i}.cap`, {
											required: false,
										})}
									/>
								</div>
							</div>
						</div>
					))
				) : (
					<div className="d-flex justify-content-center mb-3">
						<span>Empty</span>
					</div>
				)}

				{QOS_TOOLTIPS.map(el => (
					<ReactTooltip
						key={el.id}
						id={el.id}
						place={el.place as never}
						content={el.content}
					/>
				))}
			</div>
		</div>
	);
};

type FormPersonalPCCForm = {
	dnn: string;
	parentalControls: string;
	crbn: boolean;
};
const PersonalPCCForm = ({onChange, activeForm, data, onIsValid}: TProps) => {
	// validation form
	const {
		control,
		register,
		formState: {errors, isValid},
		handleSubmit,
	} = useForm({
		mode: 'all',
		defaultValues: {
			personalPCCs: defaultPersonalPCCForm(data),
		},
	});

	// eslint-disable-next-line react-hooks/exhaustive-deps
	useEffect(() => onIsValid(isValid), [isValid]);

	const {fields, append, remove} = useFieldArray({
		control,
		name: 'personalPCCs',
	});
	const dataPersonalPCCs = useWatch({control});

	const onSave = () => {};

	useEffect(() => {
		onChange(dataPersonalPCCs);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dataPersonalPCCs]);

	useEffect(() => {
		if (activeForm) {
			void handleSubmit(onSave)();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [activeForm]);

	const removeModal = (i: number) => ({
		title: 'Do you really want to remove?',
		message: 'This action can not be undone.',
		buttons: [
			{
				label: 'Yes',
				onClick: () => {
					try {
						remove(i);
					} catch (error) {
						console.error(error);
					}
				},
			},
			{
				label: 'No',
			},
		],
		closeOnEscape: true,
		closeOnClickOutside: true,
		keyCodeForClose: [8, 32],
		overlayClassName: 'overlay-custom-class-name',
	});

	return (
		<div className="rounded-3 text-bg-light p-2 mb-4">
			<div className="d-flex justify-content-between mb-2">
				<h2>Personal PCCs</h2>

				<Button
					type="button"
					onClick={() => append(defaultPersonalPCCForm() as never)}
					variant="secondary"
					style={{color: 'white'}}>
					Add
				</Button>
			</div>

			<div onSubmit={handleSubmit(onSave)}>
				{fields.length ? (
					fields.map((field, i) => (
						<div key={field.id} className="row">
							<div className="col-xs-12 col-lg-4">
								<label htmlFor="dnn">DNN</label>
								<Form.Control
									data-tooltip-id="dnn"
									id="dnn"
									aria-label="dnn"
									placeholder="*"
									{...register(`personalPCCs.${i}.dnn`, {
										required: 'The DNN is required. * is an accepted value.',
										pattern: {
											value: /^(?!\s*$)[A-Za-z0-9\-_\.\*]+$/g,
											message:
												'DNN is not valid. Accepts alphanumerics, . and *',
										},
									})}
								/>
								{errors?.personalPCCs?.[i]?.dnn?.message && (
									<small className="invalid-feedback d-block">
										{String(errors?.personalPCCs?.[i]?.dnn?.message)}
									</small>
								)}
							</div>

							<div className="col-xs-12 col-lg-5">
								<label htmlFor="parentalControls">Id</label>
								<Form.Control
									data-tooltip-id="parentalControls"
									id="parentalControls"
									aria-label="parentalControls"
									placeholder="ParentalControls"
									{...register(`personalPCCs.${i}.parentalControls`, {
										required: false,
										validate: value =>
											(value && value.trim() !== '') || 'Id cannot be empty',
										pattern: {
											value: /^[A-Za-z0-9]+(\s+[A-Za-z0-9]+)*$/,
											message:
												'Id is not valid. Only alphanumeric characters and single spaces between words are allowed.',
										},
									})}
									className={
										errors?.personalPCCs?.[i]?.parentalControls?.message
											? 'is-invalid'
											: ''
									}
								/>
								{errors?.personalPCCs?.[i]?.parentalControls?.message && (
									<small className="invalid-feedback d-block">
										{String(
											errors?.personalPCCs?.[i]?.parentalControls?.message,
										)}
									</small>
								)}
							</div>

							<div className="col-xs-12 col-lg-2 mt-4">
								<Form.Check
									aria-label="CRBN"
									label="CRBN"
									{...register(`personalPCCs.${i}.crbn`, {
										required: false,
										pattern: {
											value: /^[A-Za-z0-9\s]+$/g,
											message: 'CRBN is not valid.',
										},
									})}
								/>
							</div>

							<div className="col-xs-12 col-md-1 d-flex justify-content-end align-items-center">
								<Button
									type="button"
									onClick={() => confirmAlert(removeModal(i))}
									variant="outline-secondary"
									style={{color: 'white'}}>
									<i
										className="bi-1 bi-trash-fill text-danger"
										title=""
										data-toggle="tooltip"
										data-original-title="Delete"
									/>
								</Button>
							</div>
						</div>
					))
				) : (
					<div className="d-flex justify-content-center mb-3">
						<span>Empty</span>
					</div>
				)}

				{PCC_TOOLTIPS.map(el => (
					<ReactTooltip
						key={el.id}
						id={el.id}
						place={el.place as never}
						content={el.content}
					/>
				))}
			</div>
		</div>
	);
};

type FormDataCustomField = {
	keyField: string;
	typeField: string;
	parameterArray: string[];
};
const CustomFieldForm = ({
	onChange,
	activeForm,
	data,
	onIsValid,
	quota_manager,
}: TProps) => {
	// validation form
	const {
		control,
		trigger,
		register,
		formState: {errors, isValid},
		handleSubmit,
	} = useForm({
		mode: 'all',
		defaultValues: {
			customFields: defaultDataCustomField(data),
		},
	});

	// eslint-disable-next-line react-hooks/exhaustive-deps
	useEffect(() => onIsValid(isValid), [isValid]);

	useEffect(() => {
		if (!quota_manager) return;

		const fields = dataCustomField?.customFields ?? [];
		const quotaIndex = fields.findIndex(f => f?.keyField === 'quota_manager');

		const newField: FormDataCustomField = {
			keyField: 'quota_manager',
			typeField: 'java.lang.String',
			parameterArray: [quota_manager],
		};

		if (quotaIndex !== -1) {
			update(quotaIndex, newField);
		} else {
			append(newField as never);
		}
	}, [quota_manager]);

	const {fields, append, remove, update} = useFieldArray({
		control,
		name: 'customFields',
	});
	const dataCustomField = useWatch({control});

	const onSave = () => {};

	useEffect(() => {
		onChange(dataCustomField);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dataCustomField]);

	useEffect(() => {
		if (activeForm) {
			void handleSubmit(onSave)();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [activeForm]);

	const removeModal = (i: number) => ({
		title: 'Do you really want to remove?',
		message: 'The change is not saved until you click on Update button.',
		buttons: [
			{
				label: 'Yes',
				onClick: () => {
					try {
						remove(i);
					} catch (error) {
						console.error(error);
					}
				},
			},
			{
				label: 'No',
			},
		],
		closeOnEscape: true,
		closeOnClickOutside: true,
		keyCodeForClose: [8, 32],
		overlayClassName: 'overlay-custom-class-name',
	});

	const handleTypeFieldChange = (index: number, value: string) => {
		if (!dataCustomField?.customFields) return;

		if (dataCustomField?.customFields[index]) {
			const currentParameters = Array.isArray(
				dataCustomField?.customFields[index].parameterArray,
			)
				? dataCustomField?.customFields[index].parameterArray
				: [];
			if (currentParameters.length === 0) {
				update(index, {
					...dataCustomField.customFields[index],
					parameterArray: [''],
					keyField: dataCustomField?.customFields[index]?.keyField ?? '',
					typeField: value,
				});
			}
		}
	};

	const appendIndexParameter = (idxCustom: number, idxParameter: number) => {
		if (!dataCustomField?.customFields) return;

		if (dataCustomField?.customFields[idxCustom]) {
			const currentParameters = Array.isArray(
				dataCustomField.customFields[idxCustom].parameterArray,
			)
				? dataCustomField?.customFields[idxCustom].parameterArray
				: [];
			update(idxCustom, {
				...dataCustomField.customFields[idxCustom],
				parameterArray: [...currentParameters, ''],
				keyField: dataCustomField?.customFields[idxCustom].keyField ?? '',
				typeField: dataCustomField?.customFields[idxCustom].typeField,
			});
		}
	};

	const removeIndexParameter = (idxCustom: number, idxParameter: number) => {
		if (!dataCustomField?.customFields) return;

		if (dataCustomField?.customFields[idxCustom]) {
			const currentParameters = Array.isArray(
				dataCustomField.customFields[idxCustom].parameterArray,
			)
				? dataCustomField?.customFields[idxCustom].parameterArray
				: [];

			const updatedParameters = currentParameters.filter(
				(_: any, idx: number) => idx !== idxParameter,
			);

			dataCustomField.customFields[idxCustom].parameterArray =
				updatedParameters;

			update(idxCustom, {
				...dataCustomField.customFields[idxCustom],
				parameterArray: updatedParameters,
				keyField: dataCustomField?.customFields[idxCustom].keyField ?? '',
				typeField: dataCustomField?.customFields[idxCustom].typeField,
			});
		}
	};

	return (
		<div className="rounded-3 text-bg-light p-2 mb-4">
			<div className="d-flex justify-content-between mb-2">
				<h2>Custom Fields</h2>

				<Button
					type="button"
					onClick={() => append(defaultDataCustomField() as never)}
					variant="secondary"
					style={{color: 'white'}}>
					Add
				</Button>
			</div>

			<div onSubmit={handleSubmit(onSave)}>
				{fields.length ? (
					fields.map((field, i) => {
						if (field.keyField === 'quota_manager') {
							if (fields.length === 1) {
								return (
									<div
										key="empty-placeholder"
										className="d-flex justify-content-center mb-3">
										<span>Empty</span>
									</div>
								);
							}
							return null;
						}

						return (
							<div key={field.id} className="mb-3 pt-2 pl-2 pr-2 bg-gray">
								<div className="d-flex justify-content-end align-items-center pt-2">
									<Button
										type="button"
										onClick={() => confirmAlert(removeModal(i))}
										variant="outline-secondary"
										style={{color: 'white'}}>
										<i
											className="bi-1 bi-trash-fill text-danger"
											title=""
											data-toggle="tooltip"
											data-original-title="Delete"
										/>
									</Button>
								</div>
								<div className="col-xs-12 col-lg-5 mb-4">
									<label htmlFor="keyField">Field name</label>
									<Form.Control
										data-tooltip-id="keyField"
										id="keyField"
										aria-label="keyField"
										placeholder="name"
										{...register(`customFields.${i}.keyField`, {
											required: 'The key field is required.',
										})}
										className={
											errors?.customFields?.[i]?.keyField?.message
												? 'is-invalid'
												: ''
										}
									/>
								</div>
								<div className="row d-flex justify-content-between">
									<div className="col-xs-12 col-lg-5 mb-4 ml-3">
										<label htmlFor="tipoField">Field type</label>
										<Form.Select
											id="tipoField"
											aria-label="Default select example"
											{...register(`customFields.${i}.typeField`, {
												required: 'You must select a field type parameter.',
												onChange: e => handleTypeFieldChange(i, e.target.value),
											})}
											className={
												(errors?.customFields as any)?.[i]?.typeField?.message
													? 'is-invalid'
													: ''
											}
											value={
												dataCustomField?.customFields?.[i]?.typeField || ''
											}>
											<option value="" disabled>
												Select your option
											</option>
											<option value="java.lang.String">String</option>
											<option value="java.util.List">List of strings </option>
										</Form.Select>
										{(errors?.customFields as any)?.[i]?.typeField && (
											<small className="invalid-feedback d-block">
												{(errors?.customFields as any)?.[i]?.typeField?.message}
											</small>
										)}
									</div>
									{dataCustomField?.customFields &&
										dataCustomField?.customFields?.[i]?.typeField ===
											'java.lang.String' && (
											<>
												<div className="col-xs-12 col-lg-6 mb-4">
													<label htmlFor="Parameter">Field value</label>
													<Form.Control
														data-tooltip-id="parameterSimple"
														id="parameterSimple"
														aria-label="parameterSimple"
														placeholder="Parameter field"
														{...register(`customFields.${i}.parameterArray.0`, {
															required: 'The parameter field is required.',
														})}
														className={
															errors?.customFields?.[i]?.parameterArray?.message
																? 'is-invalid'
																: ''
														}
													/>
												</div>
											</>
										)}
									{dataCustomField?.customFields &&
										dataCustomField?.customFields?.[i]?.typeField ===
											'java.util.List' && (
											<div className="col-xs-12 col-lg-6 mb-4">
												{Array.isArray(
													dataCustomField?.customFields?.[i]?.parameterArray,
												) &&
													dataCustomField?.customFields?.[
														i
													]?.parameterArray.map((_: any, index: number) => (
														<div className="mb-2" key={index}>
															<Form.Group controlId={`fieldParameter${index}`}>
																<label htmlFor="`parameter${index}`">
																	Field value {index + 1}
																</label>
																<div className="d-flex align-items-center">
																	<Form.Control
																		data-tooltip-id="`parameter${index}`"
																		aria-label="`parameter${index}`"
																		{...register(
																			`customFields.${i}.parameterArray.${index}`,
																			{
																				required:
																					'The parameter field is required.',
																			},
																		)}
																		className={
																			errors?.customFields?.[i]?.parameterArray
																				?.message
																				? 'is-invalid'
																				: ''
																		}
																	/>
																	<Button
																		type="button"
																		className="border-0 bg-transparent d-inline btn-sm collapsed ml-2"
																		onClick={() =>
																			appendIndexParameter(i, index)
																		}>
																		<span>
																			<i className="bi-1 bi-plus-square text-primary" />
																		</span>
																	</Button>
																	<Button
																		type="button"
																		className="border-0 bg-transparent d-inline"
																		onClick={() =>
																			removeIndexParameter(i, index)
																		}>
																		<span>
																			<i className="bi-1 bi-trash-fill text-danger" />
																		</span>
																	</Button>
																</div>
															</Form.Group>
														</div>
													))}
											</div>
										)}
								</div>
							</div>
						);
					})
				) : (
					<div className="d-flex justify-content-center mb-3">
						<span>Empty</span>
					</div>
				)}
			</div>
		</div>
	);
};

type FormDataQuotaManager = {
	quotaManager: QuotaManager | '';
};

const QuotaManagerForm = ({
	onChange,
	activeForm,
	data,
	hasPlans,
	onIsValid,
}: TProps) => {
	const {
		control,
		register,
		setValue,
		formState: {errors, isValid},
		handleSubmit,
	} = useForm({
		mode: 'all',
		defaultValues: {
			quotaManager: defaultDataQuotaManager(data).quotaManager,
		},
	});

	const quotaManagerData = useWatch({control, name: 'quotaManager'});

	useEffect(() => {
		onIsValid(isValid);
	}, [isValid, onIsValid]);

	useEffect(() => {
		onChange({quotaManager: quotaManagerData});
	}, [quotaManagerData, onChange]);

	useEffect(() => {
		if (activeForm) {
			void handleSubmit(() => {})();
		}
	}, [activeForm, handleSubmit]);

	const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const selectedValue = e.target.value as
			| QuotaManager.PCRF_MS
			| QuotaManager.OCS_MS;

		if (selectedValue === QuotaManager.OCS_MS && hasPlans) {
			// Prevent update and show modal
			e.preventDefault();
			confirmAlert({
				customUI: ({onClose}) => {
					return (
						<div
							style={{
								background: 'white',
								padding: '20px',
								borderRadius: '8px',
								minWidth: '500px',
								maxWidth: '90%',
								fontSize: '16px',
								boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
								textAlign: 'center',
							}}>
							<h1 style={{whiteSpace: 'nowrap', padding: '5px'}}>
								Change Quota Manager to OCS
							</h1>
							<p>To switch to OCS, all associated plans must be removed.</p>
							<div className="d-flex justify-content-end">
								<button onClick={onClose} className="btn btn-primary">
									OK
								</button>
							</div>
						</div>
					);
				},
			});

			// Force revert to previous value
			setTimeout(() => {
				setValue('quotaManager', QuotaManager.PCRF_MS, {shouldValidate: true});
			}, 0);
		} else {
			setValue('quotaManager', selectedValue, {shouldValidate: true});
		}
	};

	return (
		<div className="rounded-3 text-bg-light p-2">
			<h2>Quota Manager</h2>
			<label htmlFor="quotaManager">Select quota manager</label>
			<select
				id="quotaManager"
				className="form-control"
				value={quotaManagerData}
				onChange={handleChange}>
				<option value={QuotaManager.PCRF_MS}>{QuotaManager.PCRF_MS}</option>
				<option value={QuotaManager.OCS_MS}>{QuotaManager.OCS_MS}</option>
			</select>
			{errors.quotaManager && (
				<span className="text-danger">This field is required</span>
			)}
		</div>
	);
};

interface IForm {
	contactInfo: FormContactInfo[] | undefined;
	formDnn: FormDnn[] | undefined;
	homeZones: FormDataHomeZone[] | undefined;
	customFields: FormDataCustomField[] | undefined;
	personalQos: FormPersonalQoS[] | undefined;
	personalPCCs: FormPersonalPCCForm[] | undefined;
}

export const defaultData = (state?: FormData) => ({
	subscriberId: state?.subscriberId ?? '',
	supi: state?.supi ?? '',
	gpsi: state?.gpsi ?? '',
	operator: 'PCRF',
	category: state?.category ?? '',
});

export const defaultContactInfoForm = (state?: FormContactInfo | null) => {
	if (!state) {
		return null;
	}

	const tmp = {
		email: state.email || null,
		msisdn: state.msisdn || null,
		contactInfoType: state.contactInfoType || null,
	};

	const areValuesEmpty = Object.values(tmp).every(value => value === null);

	return areValuesEmpty ? null : [tmp];
};

export const defaultFormDnn = (state?: SmPolicySnssaiData | null) => {
	const arr = state ? Object.entries(state).map(([_, el]) => el) : [];

	if (!arr.length) {
		return null;
	}

	const tmp = arr.map((el: any) => ({
		dnn: el?.smPolicyDnnData?.[0].dnn || '',
		subscCats: el?.smPolicyDnnData?.[0].subscCats || [''],
		gbrUl: el?.smPolicyDnnData?.[0].gbrUl?.split(' ')?.[0] || '',
		gbps: el?.smPolicyDnnData?.[0].gbrUl?.split(' ')?.[1] || '',
		gbrDl: el?.smPolicyDnnData?.[0].gbrDl?.split(' ')?.[0] || '',
		_gbps: el?.smPolicyDnnData?.[0].gbrDl?.split(' ')?.[1] || '',
		online: el?.smPolicyDnnData?.[0].online
			? el?.smPolicyDnnData?.[0].online
			: 'blank',
		offline: el?.smPolicyDnnData?.[0].offline
			? el?.smPolicyDnnData?.[0].offline
			: 'blank',
		primaryAddress: el?.smPolicyDnnData?.[0].chInfo?.primaryChfAddress || '',
		secondaryAddress:
			el?.smPolicyDnnData?.[0].chInfo?.secondaryChfAddress || '',
		refUmdLimitIds: el?.smPolicyDnnData?.[0].refUmdLimitIds || '',
	}));
	return tmp;
};

export const defaultFormSubCats = (state?: SmPolicySnssaiData | null) => {
	const arr = state ? Object.entries(state).map(([_, el]) => el) : [];

	if (!arr.length) {
		return null;
	}

	const tmp = arr.map((el: any) => el?.smPolicyDnnData?.[0].subscCats || ['']);
	return tmp[0];
};

export const defaultFormDnnMonitoring = (state?: SmPolicySnssaiData | null) => {
	const arr = state ? Object.entries(state).map(([_, el]) => el) : [];

	if (!arr.length) {
		return null;
	}

	const tmp = arr.map(
		(el: any) => el?.smPolicyDnnData?.[0].refUmdLimitIds || [''],
	);

	return tmp[0];
};

export const defaultDataHomeZone = (state?: FormDataHomeZone[] | any) => {
	const tmp = state?.map(({eutraLocation, utraLocation, typeULI}: HomeZone) => {
		if (utraLocation) {
			return {
				mcc: utraLocation?.sai?.plmnId?.mcc ?? '',
				mnc: utraLocation?.sai?.plmnId?.mnc ?? '',
				lac: utraLocation?.sai?.lac ?? '',
				sac: utraLocation?.sai?.sac ?? '',
				tac: '',
				eci: '',
				typeULI: '1',
			};
		} else if (eutraLocation) {
			const {ignoreTai, ignoreEcgi} = eutraLocation || {};

			if (!ignoreTai && !ignoreEcgi) {
				//type TAI - ECGI
				return {
					mcc: eutraLocation?.tai?.plmnId?.mcc ?? '',
					mnc: eutraLocation?.tai?.plmnId?.mnc ?? '',
					tac: eutraLocation?.tai?.tac ?? '',
					eci: eutraLocation?.ecgi?.eutraCellId ?? '',
					lac: '',
					sac: '',
					typeULI: '130',
				};
			} else if (!ignoreTai && ignoreEcgi) {
				//type TAI
				return {
					mcc: eutraLocation?.tai?.plmnId?.mcc ?? '',
					mnc: eutraLocation?.tai?.plmnId?.mnc ?? '',
					tac: eutraLocation?.tai?.tac ?? '',
					eci: '',
					lac: '',
					sac: '',
					typeULI: '128',
				};
			} else {
				//type ECGI
				return {
					mcc: eutraLocation?.ecgi?.plmnId?.mcc ?? '',
					mnc: eutraLocation?.ecgi?.plmnId?.mnc ?? '',
					tac: '',
					eci: eutraLocation?.ecgi?.eutraCellId ?? '',
					lac: '',
					sac: '',
					typeULI: '129',
				};
			}
		} else {
			return {
				mcc: '',
				mnc: '',
				tac: '',
				eci: '',
				lac: '',
				sac: '',
				typeULI: '',
			};
		}
	});
	return tmp || null;
};

export const defaultPersonalQoS = (state?: FormPersonalQoS[] | any) => {
	const keys = state ? Object.keys(state) : [];
	const arr = state ? Object.entries(state).map(([_, el]) => el) : [];

	if (!arr.length) {
		return null;
	}

	const tmp = arr.map((el: any, index: number) => ({
		dnn: keys[index] || '',
		_5qi: el['5qi'] || '',

		maxUlValue:
			el.maxbrUl && el.maxbrUl.split(' ')?.[0]
				? el.maxbrUl.split(' ')?.[0]
				: '',
		maxUlUnit:
			el.maxbrUl && el.maxbrUl.split(' ')?.[1]
				? el.maxbrUl.split(' ')?.[1]
				: '',

		maxDlValue:
			el.maxbrDl && el.maxbrDl.split(' ')?.[0]
				? el.maxbrDl.split(' ')?.[0]
				: '',
		maxDlUnit:
			el.maxbrDl && el.maxbrDl.split(' ')?.[1]
				? el.maxbrDl.split(' ')?.[1]
				: '',
		gbrUlValue:
			el.gbrUl && el.gbrUl.split(' ')?.[0] ? el.gbrUl.split(' ')?.[0] : '',
		gbrUlUnit:
			el.gbrUl && el.gbrUl.split(' ')?.[1] ? el.gbrUl.split(' ')?.[1] : '',

		gbrDlValue:
			el.gbrDl && el.gbrDl.split(' ')?.[0] ? el.gbrDl.split(' ')?.[0] : '',
		gbrDlUnit:
			el.gbrDl && el.gbrDl.split(' ')?.[1] ? el.gbrDl.split(' ')?.[1] : '',

		prio: el?.arp?.priorityLevel || '',
		cap:
			el?.arp?.preemptCap === '' || el?.arp?.preemptCap === 'NOT_PREEMPT'
				? false
				: true,
		vuln:
			el?.arp?.preemptVuln === '' || el?.arp?.preemptVuln === 'NOT_PREEMPTABLE'
				? false
				: true,
	}));

	return tmp;
};

export const defaultPersonalPCCForm = (
	state?: PersonalPCCS | null,
): FormPersonalPCCForm[] | null => {
	if (!state) {
		return null;
	}

	const arr = Object.entries(state).map(([dnn, personalPcc]) => ({
		dnn: personalPcc?.dnn || dnn,
		parentalControls: personalPcc?.pccRuleId || '',
		crbn: personalPcc?.crbn || false,
	}));

	return arr.length ? arr : null;
};

export const defaultDataCustomField = (
	state?: FormDataCustomField[] | null | any,
) => {
	const keys = state ? Object.keys(state) : [];
	const arr = state ? Object.entries(state).map(([_, el]) => el) : [];

	if (!arr.length && !keys.length) {
		return null;
	}

	const tmp = arr.map((el: any, index: number) => {
		if (el.type === 'java.lang.String') {
			return {
				keyField: keys[index] || '',
				typeField: el.type ?? '',
				parameterArray: el.parameter ? [el.parameter] : [''],
			};
		} else {
			return {
				keyField: keys[index] || '',
				typeField: el.type ?? '',
				parameterArray: Array.isArray(el.parameter) ? el.parameter : [''],
			};
		}
	});

	// ✅ Append "quota_manager" if missing
	const hasQuotaManager = tmp.some(
		(el: FormDataCustomField) => el.keyField === 'quota_manager',
	);
	if (!hasQuotaManager && typeof state?.quota_manager?.parameter === 'string') {
		tmp.push({
			keyField: 'quota_manager',
			typeField: 'java.lang.String',
			parameterArray: [state.quota_manager.parameter],
		});
	}

	return tmp;
};

export const defaultDataQuotaManager = (
	state?: Record<string, any> | null,
): {quotaManager: QuotaManager.PCRF_MS | QuotaManager.OCS_MS} => {
	const keys = state ? Object.keys(state) : [];
	const arr = state ? Object.entries(state).map(([_, el]) => el) : [];

	let value: string = '';

	for (let index = 0; index < arr.length; index++) {
		const el = arr[index];
		const key = keys[index] || '';

		if (key === 'quota_manager') {
			value = el.parameter;
			break;
		}
	}

	return {
		quotaManager:
			value === QuotaManager.OCS_MS
				? QuotaManager.OCS_MS
				: QuotaManager.PCRF_MS,
	};
};

export const transformFormData = (formData: IForm) => {
	if (!formData?.customFields) return null;

	return formData.customFields.reduce((customFields: any, fieldValue: any) => {
		if (fieldValue.typeField === 'java.lang.String') {
			customFields[fieldValue.keyField] = {
				parameter: fieldValue.parameterArray[0],
				type: fieldValue.typeField,
			};
		} else {
			customFields[fieldValue.keyField] = {
				parameter: fieldValue.parameterArray,
				type: fieldValue.typeField,
			};
		}

		return customFields;
	}, {} as Record<string, GenericObject<string[]>>);
};

export default SubscriberProfileDetail;
